(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@redux-saga/core/effects"), require("@reduxjs/toolkit"), require("@innovyze/lib_get_service"), require("@innovyze/stylovyze"), require("i18next"));
	else if(typeof define === 'function' && define.amd)
		define(["@redux-saga/core/effects", "@Reduxjs/Toolkit", "@innovyze/lib_get_service", "@Innovyze/Stylovyze", "I18next"], factory);
	else if(typeof exports === 'object')
		exports["app-MODULE-NAME"] = factory(require("@redux-saga/core/effects"), require("@reduxjs/toolkit"), require("@innovyze/lib_get_service"), require("@innovyze/stylovyze"), require("i18next"));
	else
		root["app-MODULE-NAME"] = factory(root["@redux-saga/core/effects"], root["@Reduxjs/Toolkit"], root["@innovyze/lib_get_service"], root["@Innovyze/Stylovyze"], root["I18next"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__, __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__, __WEBPACK_EXTERNAL_MODULE_i18next__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../node_modules/browser-cookies/src/browser-cookies.js":
/*!**************************************************************!*\
  !*** ../node_modules/browser-cookies/src/browser-cookies.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports) => {

exports.defaults = {};

exports.set = function(name, value, options) {
  // Retrieve options and defaults
  var opts = options || {};
  var defaults = exports.defaults;

  // Apply default value for unspecified options
  var expires  = opts.expires  || defaults.expires;
  var domain   = opts.domain   || defaults.domain;
  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
  var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;

  // Determine cookie expiration date
  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
  var expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
      // else expires should be either a Date object or in a format recognized by Date.parse()
      expires
  ) : 0;

  // Set cookie
  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
  .replace('(', '%28')
  .replace(')', '%29') +
  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
  (domain   ? ';domain=' + domain     : '') +                                      // Add domain
  (path     ? ';path='   + path       : '') +                                      // Add path
  (secure   ? ';secure'               : '') +                                      // Add secure option
  (httponly ? ';httponly'             : '') +                                      // Add httponly option
  (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
};

exports.get = function(name) {
  var cookies = document.cookie.split(';');
  
  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));

    // Return cookie value if the name matches
    if (cookie_name === name) {
      return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
  }

  // Return `null` as the cookie was not found
  return null;
};

exports.erase = function(name, options) {
  exports.set(name, '', {
    expires:  -1,
    domain:   options && options.domain,
    path:     options && options.path,
    secure:   0,
    httponly: 0}
  );
};

exports.all = function() {
  var all = {};
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    // add the cookie name and value to the `all` object
    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
    all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
  }

  return all;
};


/***/ }),

/***/ "../node_modules/launchdarkly-js-client-sdk/dist/ldclient.es.js":
/*!**********************************************************************!*\
  !*** ../node_modules/launchdarkly-js-client-sdk/dist/ldclient.es.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   basicLogger: () => (/* binding */ Nt),
/* harmony export */   createConsoleLogger: () => (/* binding */ $t),
/* harmony export */   "default": () => (/* binding */ Mt),
/* harmony export */   initialize: () => (/* binding */ Ft),
/* harmony export */   version: () => (/* binding */ Vt)
/* harmony export */ });
function e(e){function t(e,t){Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor),this.message=e,this.code=t}return t.prototype=new Error,t.prototype.name=e,t.prototype.constructor=t,t}const t=e("LaunchDarklyUnexpectedResponseError"),n=e("LaunchDarklyInvalidEnvironmentIdError"),r=e("LaunchDarklyInvalidUserError"),o=e("LaunchDarklyInvalidEventKeyError"),i=e("LaunchDarklyInvalidArgumentError"),a=e("LaunchDarklyFlagFetchError");for(var s={LDUnexpectedResponseError:t,LDInvalidEnvironmentIdError:n,LDInvalidUserError:r,LDInvalidEventKeyError:o,LDInvalidArgumentError:i,LDInvalidDataError:e("LaunchDarklyInvalidDataError"),LDFlagFetchError:a,LDTimeoutError:e("LaunchDarklyTimeoutError"),isHttpErrorRecoverable:function(e){return!(e>=400&&e<500)||(400===e||408===e||429===e)}},c=function(e){var t=m(e),n=t[0],r=t[1];return 3*(n+r)/4-r},u=function(e){var t,n,r=m(e),o=r[0],i=r[1],a=new g(function(e,t,n){return 3*(t+n)/4-n}(0,o,i)),s=0,c=i>0?o-4:o;for(n=0;n<c;n+=4)t=f[e.charCodeAt(n)]<<18|f[e.charCodeAt(n+1)]<<12|f[e.charCodeAt(n+2)]<<6|f[e.charCodeAt(n+3)],a[s++]=t>>16&255,a[s++]=t>>8&255,a[s++]=255&t;2===i&&(t=f[e.charCodeAt(n)]<<2|f[e.charCodeAt(n+1)]>>4,a[s++]=255&t);1===i&&(t=f[e.charCodeAt(n)]<<10|f[e.charCodeAt(n+1)]<<4|f[e.charCodeAt(n+2)]>>2,a[s++]=t>>8&255,a[s++]=255&t);return a},l=function(e){for(var t,n=e.length,r=n%3,o=[],i=16383,a=0,s=n-r;a<s;a+=i)o.push(h(e,a,a+i>s?s:a+i));1===r?(t=e[n-1],o.push(d[t>>2]+d[t<<4&63]+"==")):2===r&&(t=(e[n-2]<<8)+e[n-1],o.push(d[t>>10]+d[t>>4&63]+d[t<<2&63]+"="));return o.join("")},d=[],f=[],g="undefined"!=typeof Uint8Array?Uint8Array:Array,v="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",p=0;p<64;++p)d[p]=v[p],f[v.charCodeAt(p)]=p;function m(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function h(e,t,n){for(var r,o,i=[],a=t;a<n;a+=3)r=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),i.push(d[(o=r)>>18&63]+d[o>>12&63]+d[o>>6&63]+d[63&o]);return i.join("")}f["-".charCodeAt(0)]=62,f["_".charCodeAt(0)]=63;var y={byteLength:c,toByteArray:u,fromByteArray:l},w=Array.isArray,b=Object.keys,k=Object.prototype.hasOwnProperty,E=function e(t,n){if(t===n)return!0;if(t&&n&&"object"==typeof t&&"object"==typeof n){var r,o,i,a=w(t),s=w(n);if(a&&s){if((o=t.length)!=n.length)return!1;for(r=o;0!=r--;)if(!e(t[r],n[r]))return!1;return!0}if(a!=s)return!1;var c=t instanceof Date,u=n instanceof Date;if(c!=u)return!1;if(c&&u)return t.getTime()==n.getTime();var l=t instanceof RegExp,d=n instanceof RegExp;if(l!=d)return!1;if(l&&d)return t.toString()==n.toString();var f=b(t);if((o=f.length)!==b(n).length)return!1;for(r=o;0!=r--;)if(!k.call(n,f[r]))return!1;for(r=o;0!=r--;)if(!e(t[i=f[r]],n[i]))return!1;return!0}return t!=t&&n!=n};const D=["key","ip","country","email","firstName","lastName","avatar","name"];function x(e){const t=unescape(encodeURIComponent(e));return y.fromByteArray(function(e){const t=[];for(let n=0;n<e.length;n++)t.push(e.charCodeAt(n));return t}(t))}function C(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var P,S={appendUrlPath:function(e,t){return(e.endsWith("/")?e.substring(0,e.length-1):e)+(t.startsWith("/")?"":"/")+t},base64URLEncode:function(e){return x(e).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_")},btoa:x,clone:function(e){return JSON.parse(JSON.stringify(e))},deepEquals:function(e,t){return E(e,t)},extend:function(...e){return e.reduce(((e,t)=>({...e,...t})),{})},getLDUserAgentString:function(e){const t=e.version||"?";return e.userAgent+"/"+t},objectHasOwnProperty:C,onNextTick:function(e){setTimeout(e,0)},sanitizeContext:function(e){if(!e)return e;let t;return null!==e.kind&&void 0!==e.kind||D.forEach((n=>{const r=e[n];void 0!==r&&"string"!=typeof r&&(t=t||{...e},t[n]=String(r))})),t||e},transformValuesToVersionedValues:function(e){const t={};for(const n in e)C(e,n)&&(t[n]={value:e[n],version:0});return t},transformVersionedValuesToValues:function(e){const t={};for(const n in e)C(e,n)&&(t[n]=e[n].value);return t},wrapPromiseCallback:function(e,t){const n=e.then((e=>(t&&setTimeout((()=>{t(null,e)}),0),e)),(e=>{if(!t)return Promise.reject(e);setTimeout((()=>{t(e,null)}),0)}));return t?void 0:n}},I=new Uint8Array(16);function O(){if(!P&&!(P="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return P(I)}var T=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;function L(e){return"string"==typeof e&&T.test(e)}for(var U,R,A=[],j=0;j<256;++j)A.push((j+256).toString(16).substr(1));function F(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(A[e[t+0]]+A[e[t+1]]+A[e[t+2]]+A[e[t+3]]+"-"+A[e[t+4]]+A[e[t+5]]+"-"+A[e[t+6]]+A[e[t+7]]+"-"+A[e[t+8]]+A[e[t+9]]+"-"+A[e[t+10]]+A[e[t+11]]+A[e[t+12]]+A[e[t+13]]+A[e[t+14]]+A[e[t+15]]).toLowerCase();if(!L(n))throw TypeError("Stringified UUID is invalid");return n}var N=0,$=0;function V(e){if(!L(e))throw TypeError("Invalid UUID");var t,n=new Uint8Array(16);return n[0]=(t=parseInt(e.slice(0,8),16))>>>24,n[1]=t>>>16&255,n[2]=t>>>8&255,n[3]=255&t,n[4]=(t=parseInt(e.slice(9,13),16))>>>8,n[5]=255&t,n[6]=(t=parseInt(e.slice(14,18),16))>>>8,n[7]=255&t,n[8]=(t=parseInt(e.slice(19,23),16))>>>8,n[9]=255&t,n[10]=(t=parseInt(e.slice(24,36),16))/1099511627776&255,n[11]=t/4294967296&255,n[12]=t>>>24&255,n[13]=t>>>16&255,n[14]=t>>>8&255,n[15]=255&t,n}function M(e,t,n){function r(e,r,o,i){if("string"==typeof e&&(e=function(e){e=unescape(encodeURIComponent(e));for(var t=[],n=0;n<e.length;++n)t.push(e.charCodeAt(n));return t}(e)),"string"==typeof r&&(r=V(r)),16!==r.length)throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");var a=new Uint8Array(16+e.length);if(a.set(r),a.set(e,r.length),(a=n(a))[6]=15&a[6]|t,a[8]=63&a[8]|128,o){i=i||0;for(var s=0;s<16;++s)o[i+s]=a[s];return o}return F(a)}try{r.name=e}catch(e){}return r.DNS="6ba7b810-9dad-11d1-80b4-00c04fd430c8",r.URL="6ba7b811-9dad-11d1-80b4-00c04fd430c8",r}function q(e){return 14+(e+64>>>9<<4)+1}function H(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function z(e,t,n,r,o,i){return H((a=H(H(t,e),H(r,i)))<<(s=o)|a>>>32-s,n);var a,s}function K(e,t,n,r,o,i,a){return z(t&n|~t&r,e,t,o,i,a)}function _(e,t,n,r,o,i,a){return z(t&r|n&~r,e,t,o,i,a)}function J(e,t,n,r,o,i,a){return z(t^n^r,e,t,o,i,a)}function B(e,t,n,r,o,i,a){return z(n^(t|~r),e,t,o,i,a)}var G=M("v3",48,(function(e){if("string"==typeof e){var t=unescape(encodeURIComponent(e));e=new Uint8Array(t.length);for(var n=0;n<t.length;++n)e[n]=t.charCodeAt(n)}return function(e){for(var t=[],n=32*e.length,r="0123456789abcdef",o=0;o<n;o+=8){var i=e[o>>5]>>>o%32&255,a=parseInt(r.charAt(i>>>4&15)+r.charAt(15&i),16);t.push(a)}return t}(function(e,t){e[t>>5]|=128<<t%32,e[q(t)-1]=t;for(var n=1732584193,r=-271733879,o=-1732584194,i=271733878,a=0;a<e.length;a+=16){var s=n,c=r,u=o,l=i;n=K(n,r,o,i,e[a],7,-680876936),i=K(i,n,r,o,e[a+1],12,-389564586),o=K(o,i,n,r,e[a+2],17,606105819),r=K(r,o,i,n,e[a+3],22,-1044525330),n=K(n,r,o,i,e[a+4],7,-176418897),i=K(i,n,r,o,e[a+5],12,1200080426),o=K(o,i,n,r,e[a+6],17,-1473231341),r=K(r,o,i,n,e[a+7],22,-45705983),n=K(n,r,o,i,e[a+8],7,1770035416),i=K(i,n,r,o,e[a+9],12,-1958414417),o=K(o,i,n,r,e[a+10],17,-42063),r=K(r,o,i,n,e[a+11],22,-1990404162),n=K(n,r,o,i,e[a+12],7,1804603682),i=K(i,n,r,o,e[a+13],12,-40341101),o=K(o,i,n,r,e[a+14],17,-1502002290),n=_(n,r=K(r,o,i,n,e[a+15],22,1236535329),o,i,e[a+1],5,-165796510),i=_(i,n,r,o,e[a+6],9,-1069501632),o=_(o,i,n,r,e[a+11],14,643717713),r=_(r,o,i,n,e[a],20,-373897302),n=_(n,r,o,i,e[a+5],5,-701558691),i=_(i,n,r,o,e[a+10],9,38016083),o=_(o,i,n,r,e[a+15],14,-660478335),r=_(r,o,i,n,e[a+4],20,-405537848),n=_(n,r,o,i,e[a+9],5,568446438),i=_(i,n,r,o,e[a+14],9,-1019803690),o=_(o,i,n,r,e[a+3],14,-187363961),r=_(r,o,i,n,e[a+8],20,1163531501),n=_(n,r,o,i,e[a+13],5,-1444681467),i=_(i,n,r,o,e[a+2],9,-51403784),o=_(o,i,n,r,e[a+7],14,1735328473),n=J(n,r=_(r,o,i,n,e[a+12],20,-1926607734),o,i,e[a+5],4,-378558),i=J(i,n,r,o,e[a+8],11,-2022574463),o=J(o,i,n,r,e[a+11],16,1839030562),r=J(r,o,i,n,e[a+14],23,-35309556),n=J(n,r,o,i,e[a+1],4,-1530992060),i=J(i,n,r,o,e[a+4],11,1272893353),o=J(o,i,n,r,e[a+7],16,-155497632),r=J(r,o,i,n,e[a+10],23,-1094730640),n=J(n,r,o,i,e[a+13],4,681279174),i=J(i,n,r,o,e[a],11,-358537222),o=J(o,i,n,r,e[a+3],16,-722521979),r=J(r,o,i,n,e[a+6],23,76029189),n=J(n,r,o,i,e[a+9],4,-640364487),i=J(i,n,r,o,e[a+12],11,-421815835),o=J(o,i,n,r,e[a+15],16,530742520),n=B(n,r=J(r,o,i,n,e[a+2],23,-995338651),o,i,e[a],6,-198630844),i=B(i,n,r,o,e[a+7],10,1126891415),o=B(o,i,n,r,e[a+14],15,-1416354905),r=B(r,o,i,n,e[a+5],21,-57434055),n=B(n,r,o,i,e[a+12],6,1700485571),i=B(i,n,r,o,e[a+3],10,-1894986606),o=B(o,i,n,r,e[a+10],15,-1051523),r=B(r,o,i,n,e[a+1],21,-2054922799),n=B(n,r,o,i,e[a+8],6,1873313359),i=B(i,n,r,o,e[a+15],10,-30611744),o=B(o,i,n,r,e[a+6],15,-1560198380),r=B(r,o,i,n,e[a+13],21,1309151649),n=B(n,r,o,i,e[a+4],6,-145523070),i=B(i,n,r,o,e[a+11],10,-1120210379),o=B(o,i,n,r,e[a+2],15,718787259),r=B(r,o,i,n,e[a+9],21,-343485551),n=H(n,s),r=H(r,c),o=H(o,u),i=H(i,l)}return[n,r,o,i]}(function(e){if(0===e.length)return[];for(var t=8*e.length,n=new Uint32Array(q(t)),r=0;r<t;r+=8)n[r>>5]|=(255&e[r/8])<<r%32;return n}(e),8*e.length))})),W=G;function X(e,t,n,r){switch(e){case 0:return t&n^~t&r;case 1:case 3:return t^n^r;case 2:return t&n^t&r^n&r}}function Q(e,t){return e<<t|e>>>32-t}var Y=M("v5",80,(function(e){var t=[1518500249,1859775393,2400959708,3395469782],n=[1732584193,4023233417,2562383102,271733878,3285377520];if("string"==typeof e){var r=unescape(encodeURIComponent(e));e=[];for(var o=0;o<r.length;++o)e.push(r.charCodeAt(o))}else Array.isArray(e)||(e=Array.prototype.slice.call(e));e.push(128);for(var i=e.length/4+2,a=Math.ceil(i/16),s=new Array(a),c=0;c<a;++c){for(var u=new Uint32Array(16),l=0;l<16;++l)u[l]=e[64*c+4*l]<<24|e[64*c+4*l+1]<<16|e[64*c+4*l+2]<<8|e[64*c+4*l+3];s[c]=u}s[a-1][14]=8*(e.length-1)/Math.pow(2,32),s[a-1][14]=Math.floor(s[a-1][14]),s[a-1][15]=8*(e.length-1)&4294967295;for(var d=0;d<a;++d){for(var f=new Uint32Array(80),g=0;g<16;++g)f[g]=s[d][g];for(var v=16;v<80;++v)f[v]=Q(f[v-3]^f[v-8]^f[v-14]^f[v-16],1);for(var p=n[0],m=n[1],h=n[2],y=n[3],w=n[4],b=0;b<80;++b){var k=Math.floor(b/20),E=Q(p,5)+X(k,m,h,y)+w+t[k]+f[b]>>>0;w=y,y=h,h=Q(m,30)>>>0,m=p,p=E}n[0]=n[0]+p>>>0,n[1]=n[1]+m>>>0,n[2]=n[2]+h>>>0,n[3]=n[3]+y>>>0,n[4]=n[4]+w>>>0}return[n[0]>>24&255,n[0]>>16&255,n[0]>>8&255,255&n[0],n[1]>>24&255,n[1]>>16&255,n[1]>>8&255,255&n[1],n[2]>>24&255,n[2]>>16&255,n[2]>>8&255,255&n[2],n[3]>>24&255,n[3]>>16&255,n[3]>>8&255,255&n[3],n[4]>>24&255,n[4]>>16&255,n[4]>>8&255,255&n[4]]})),Z=Y;var ee=Object.freeze({__proto__:null,v1:function(e,t,n){var r=t&&n||0,o=t||new Array(16),i=(e=e||{}).node||U,a=void 0!==e.clockseq?e.clockseq:R;if(null==i||null==a){var s=e.random||(e.rng||O)();null==i&&(i=U=[1|s[0],s[1],s[2],s[3],s[4],s[5]]),null==a&&(a=R=16383&(s[6]<<8|s[7]))}var c=void 0!==e.msecs?e.msecs:Date.now(),u=void 0!==e.nsecs?e.nsecs:$+1,l=c-N+(u-$)/1e4;if(l<0&&void 0===e.clockseq&&(a=a+1&16383),(l<0||c>N)&&void 0===e.nsecs&&(u=0),u>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");N=c,$=u,R=a;var d=(1e4*(268435455&(c+=122192928e5))+u)%4294967296;o[r++]=d>>>24&255,o[r++]=d>>>16&255,o[r++]=d>>>8&255,o[r++]=255&d;var f=c/4294967296*1e4&268435455;o[r++]=f>>>8&255,o[r++]=255&f,o[r++]=f>>>24&15|16,o[r++]=f>>>16&255,o[r++]=a>>>8|128,o[r++]=255&a;for(var g=0;g<6;++g)o[r+g]=i[g];return t||F(o)},v3:W,v4:function(e,t,n){var r=(e=e||{}).random||(e.rng||O)();if(r[6]=15&r[6]|64,r[8]=63&r[8]|128,t){n=n||0;for(var o=0;o<16;++o)t[n+o]=r[o];return t}return F(r)},v5:Z,NIL:"00000000-0000-0000-0000-000000000000",version:function(e){if(!L(e))throw TypeError("Invalid UUID");return parseInt(e.substr(14,1),16)},validate:L,stringify:F,parse:V});const te=["debug","info","warn","error","none"];var ne={commonBasicLogger:function(e,t){if(e&&e.destination&&"function"!=typeof e.destination)throw new Error("destination for basicLogger was set to a non-function");function n(e){return function(t){console&&console[e]&&console[e].call(console,t)}}const r=e&&e.destination?[e.destination,e.destination,e.destination,e.destination]:[n("log"),n("info"),n("warn"),n("error")],o=!(!e||!e.destination),i=e&&void 0!==e.prefix&&null!==e.prefix?e.prefix:"[LaunchDarkly] ";let a=1;if(e&&e.level)for(let t=0;t<te.length;t++)te[t]===e.level&&(a=t);function s(e,n,a){if(a.length<1)return;let s;const c=o?n+": "+i:i;if(1!==a.length&&t){const e=[...a];e[0]=c+e[0],s=t(...e)}else s=c+a[0];try{r[e](s)}catch(e){console&&console.log&&console.log("[LaunchDarkly] Configured logger's "+n+" method threw an exception: "+e)}}const c={};for(let e=0;e<te.length;e++){const t=te[e];if("none"!==t)if(e<a)c[t]=()=>{};else{const n=e;c[t]=function(){s(n,t,arguments)}}}return c},validateLogger:function(e){te.forEach((t=>{if("none"!==t&&(!e[t]||"function"!=typeof e[t]))throw new Error("Provided logger instance must support logger."+t+"(...) method")}))}};function re(e){return e&&e.message?e.message:"string"==typeof e||e instanceof String?e:JSON.stringify(e)}const oe=" Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";var ie={bootstrapInvalid:function(){return"LaunchDarkly bootstrap data is not available because the back end could not read the flags."},bootstrapOldFormat:function(){return"LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly."+oe},clientInitialized:function(){return"LaunchDarkly client initialized"},clientNotReady:function(){return"LaunchDarkly client is not ready"},debugEnqueueingEvent:function(e){return'enqueueing "'+e+'" event'},debugPostingDiagnosticEvent:function(e){return"sending diagnostic event ("+e.kind+")"},debugPostingEvents:function(e){return"sending "+e+" events"},debugStreamDelete:function(e){return'received streaming deletion for flag "'+e+'"'},debugStreamDeleteIgnored:function(e){return'received streaming deletion for flag "'+e+'" but ignored due to version check'},debugStreamPatch:function(e){return'received streaming update for flag "'+e+'"'},debugStreamPatchIgnored:function(e){return'received streaming update for flag "'+e+'" but ignored due to version check'},debugStreamPing:function(){return"received ping message from stream"},debugPolling:function(e){return"polling for feature flags at "+e},debugStreamPut:function(){return"received streaming update for all flags"},deprecated:function(e,t){return t?'"'+e+'" is deprecated, please use "'+t+'"':'"'+e+'" is deprecated'},environmentNotFound:function(){return"Environment not found. Double check that you specified a valid environment/client-side ID."+oe},environmentNotSpecified:function(){return"No environment/client-side ID was specified."+oe},errorFetchingFlags:function(e){return"Error fetching flag settings: "+re(e)},eventCapacityExceeded:function(){return"Exceeded event queue capacity. Increase capacity to avoid dropping events."},eventWithoutContext:function(){return"Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript"},httpErrorMessage:function(e,t,n){return"Received error "+e+(401===e?" (invalid SDK key)":"")+" for "+t+" - "+(s.isHttpErrorRecoverable(e)?n:"giving up permanently")},httpUnavailable:function(){return"Cannot make HTTP requests in this environment."+oe},identifyDisabled:function(){return"identify() has no effect here; it must be called on the main client instance"},inspectorMethodError:(e,t)=>`an inspector: "${t}" of type: "${e}" generated an exception`,invalidContentType:function(e){return'Expected application/json content type but got "'+e+'"'},invalidData:function(){return"Invalid data received from LaunchDarkly; connection may have been interrupted"},invalidInspector:(e,t)=>`an inspector: "${t}" of an invalid type (${e}) was configured`,invalidKey:function(){return"Event key must be a string"},invalidMetricValue:e=>`The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`,invalidContext:function(){return"Invalid context specified."+oe},invalidTagValue:e=>`Config option "${e}" must only contain letters, numbers, ., _ or -.`,localStorageUnavailable:function(e){return"local storage is unavailable: "+re(e)},networkError:e=>"network error"+(e?" ("+e+")":""),optionBelowMinimum:(e,t,n)=>'Config option "'+e+'" was set to '+t+", changing to minimum value of "+n,streamClosing:function(){return"Closing stream connection"},streamConnecting:function(e){return"Opening stream connection to "+e},streamError:function(e,t){return"Error on stream connection: "+re(e)+", will continue retrying after "+t+" milliseconds."},tagValueTooLong:e=>`Value of "${e}" was longer than 64 characters and was discarded.`,unknownCustomEventKey:function(e){return'Custom event "'+e+'" does not exist'},unknownOption:e=>'Ignoring unknown config option "'+e+'"',contextNotSpecified:function(){return"No context specified."+oe},unrecoverableStreamError:e=>`Error on stream connection ${re(e)}, giving up permanently`,wrongOptionType:(e,t,n)=>'Config option "'+e+'" should be of type '+t+", got "+n+", using default value",wrongOptionTypeBoolean:(e,t)=>'Config option "'+e+'" should be a boolean, got '+t+", converting to boolean"};const{validateLogger:ae}=ne,se={baseUrl:{default:"https://app.launchdarkly.com"},streamUrl:{default:"https://clientstream.launchdarkly.com"},eventsUrl:{default:"https://events.launchdarkly.com"},sendEvents:{default:!0},streaming:{type:"boolean"},sendLDHeaders:{default:!0},requestHeaderTransform:{type:"function"},sendEventsOnlyForVariation:{default:!1},useReport:{default:!1},evaluationReasons:{default:!1},eventCapacity:{default:100,minimum:1},flushInterval:{default:2e3,minimum:2e3},samplingInterval:{default:0,minimum:0},streamReconnectDelay:{default:1e3,minimum:0},allAttributesPrivate:{default:!1},privateAttributes:{default:[]},bootstrap:{type:"string|object"},diagnosticRecordingInterval:{default:9e5,minimum:2e3},diagnosticOptOut:{default:!1},wrapperName:{type:"string"},wrapperVersion:{type:"string"},stateProvider:{type:"object"},application:{validator:function(e,t,n){const r={};t.id&&(r.id=le(`${e}.id`,t.id,n));t.version&&(r.version=le(`${e}.version`,t.version,n));return r}},inspectors:{default:[]}},ce=/^(\w|\.|-)+$/;function ue(e){return e&&e.replace(/\/+$/,"")}function le(e,t,n){if("string"==typeof t&&t.match(ce)){if(!(t.length>64))return t;n.warn(ie.tagValueTooLong(e))}else n.warn(ie.invalidTagValue(e))}var de={baseOptionDefs:se,validate:function(e,t,n,r){const o=S.extend({logger:{default:r}},se,n),i={};function a(e){S.onNextTick((()=>{t&&t.maybeReportError(new s.LDInvalidArgumentError(e))}))}let c=S.extend({},e||{});return function(e){const t=e;Object.keys(i).forEach((e=>{if(void 0!==t[e]){const n=i[e];r&&r.warn(ie.deprecated(e,n)),n&&(void 0===t[n]&&(t[n]=t[e]),delete t[e])}}))}(c),c=function(e){const t=S.extend({},e);return Object.keys(o).forEach((e=>{void 0!==t[e]&&null!==t[e]||(t[e]=o[e]&&o[e].default)})),t}(c),c=function(e){const t=S.extend({},e),n=e=>{if(null===e)return"any";if(void 0===e)return;if(Array.isArray(e))return"array";const t=typeof e;return"boolean"===t||"string"===t||"number"===t||"function"===t?t:"object"};return Object.keys(e).forEach((i=>{const s=e[i];if(null!=s){const c=o[i];if(void 0===c)a(ie.unknownOption(i));else{const o=c.type||n(c.default),u=c.validator;if(u){const n=u(i,e[i],r);void 0!==n?t[i]=n:delete t[i]}else if("any"!==o){const e=o.split("|"),r=n(s);e.indexOf(r)<0?"boolean"===o?(t[i]=!!s,a(ie.wrongOptionTypeBoolean(i,r))):(a(ie.wrongOptionType(i,o,r)),t[i]=c.default):"number"===r&&void 0!==c.minimum&&s<c.minimum&&(a(ie.optionBelowMinimum(i,s,c.minimum)),t[i]=c.minimum)}}}})),t.baseUrl=ue(t.baseUrl),t.streamUrl=ue(t.streamUrl),t.eventsUrl=ue(t.eventsUrl),t}(c),ae(c.logger),c},getTags:function(e){const t={};return e&&(e.application&&void 0!==e.application.id&&null!==e.application.id&&(t["application-id"]=[e.application.id]),e.application&&void 0!==e.application.version&&null!==e.application.id&&(t["application-version"]=[e.application.version])),t}};const{getLDUserAgentString:fe}=S;var ge={getLDHeaders:function(e,t){if(t&&!t.sendLDHeaders)return{};const n={};n[e.userAgentHeaderName||"User-Agent"]=fe(e),t&&t.wrapperName&&(n["X-LaunchDarkly-Wrapper"]=t.wrapperVersion?t.wrapperName+"/"+t.wrapperVersion:t.wrapperName);const r=de.getTags(t),o=Object.keys(r);return o.length&&(n["x-launchdarkly-tags"]=o.sort().map((e=>Array.isArray(r[e])?r[e].sort().map((t=>`${e}/${t}`)):[`${e}/${r[e]}`])).reduce(((e,t)=>e.concat(t)),[]).join(" ")),n},transformHeaders:function(e,t){return t&&t.requestHeaderTransform?t.requestHeaderTransform({...e}):e}};const{v1:ve}=ee,{getLDHeaders:pe,transformHeaders:me}=ge;var he=function(e,t,n){const r=S.extend({"Content-Type":"application/json"},pe(e,n)),o={};return o.sendEvents=(t,o,i)=>{if(!e.httpRequest)return Promise.resolve();const a=JSON.stringify(t),c=i?null:ve();return function t(u){const l=i?r:S.extend({},r,{"X-LaunchDarkly-Event-Schema":"4","X-LaunchDarkly-Payload-ID":c});return e.httpRequest("POST",o,me(l,n),a).promise.then((e=>{if(e)return e.status>=400&&s.isHttpErrorRecoverable(e.status)&&u?t(!1):function(e){const t={status:e.status},n=e.header("date");if(n){const e=Date.parse(n);e&&(t.serverTime=e)}return t}(e)})).catch((()=>u?t(!1):Promise.reject()))}(!0).catch((()=>{}))},o};const{commonBasicLogger:ye}=ne;function we(e){return"string"==typeof e&&"kind"!==e&&e.match(/^(\w|\.|-)+$/)}function be(e){return e.includes("%")||e.includes(":")?e.replace(/%/g,"%25").replace(/:/g,"%3A"):e}var ke={checkContext:function(e,t){if(e){if(t&&(void 0===e.kind||null===e.kind))return void 0!==e.key&&null!==e.key;const n=e.key,r=void 0===e.kind?"user":e.kind,o=we(r),i="multi"===r||null!=n&&""!==n;if("multi"===r){const t=Object.keys(e).filter((e=>"kind"!==e));return i&&t.every((e=>we(e)))&&t.every((t=>{const n=e[t].key;return null!=n&&""!==n}))}return i&&o}return!1},getContextKeys:function(e,t=ye()){if(!e)return;const n={},{kind:r,key:o}=e;switch(r){case void 0:n.user=`${o}`;break;case"multi":Object.entries(e).filter((([e])=>"kind"!==e)).forEach((([e,t])=>{t&&t.key&&(n[e]=t.key)}));break;case null:t.warn(`null is not a valid context kind: ${e}`);break;case"":t.warn(`'' is not a valid context kind: ${e}`);break;default:n[r]=`${o}`}return n},getContextKinds:function(e){return e?null===e.kind||void 0===e.kind?["user"]:"multi"!==e.kind?[e.kind]:Object.keys(e).filter((e=>"kind"!==e)):[]},getCanonicalKey:function(e){if(e){if((void 0===e.kind||null===e.kind||"user"===e.kind)&&e.key)return e.key;if("multi"!==e.kind&&e.key)return`${e.kind}:${be(e.key)}`;if("multi"===e.kind)return Object.keys(e).sort().filter((e=>"kind"!==e)).map((t=>`${t}:${be(e[t].key)}`)).join(":")}}};const{getContextKinds:Ee}=ke;var De=function(){const e={};let t=0,n=0,r={},o={};return e.summarizeEvent=e=>{if("feature"===e.kind){const i=e.key+":"+(null!==e.variation&&void 0!==e.variation?e.variation:"")+":"+(null!==e.version&&void 0!==e.version?e.version:""),a=r[i];let s=o[e.key];s||(s=new Set,o[e.key]=s),function(e){return e.context?Ee(e.context):e.contextKeys?Object.keys(e.contextKeys):[]}(e).forEach((e=>s.add(e))),a?a.count=a.count+1:r[i]={count:1,key:e.key,version:e.version,variation:e.variation,value:e.value,default:e.default},(0===t||e.creationDate<t)&&(t=e.creationDate),e.creationDate>n&&(n=e.creationDate)}},e.getSummary=()=>{const e={};let i=!0;for(const t of Object.values(r)){let n=e[t.key];n||(n={default:t.default,counters:[],contextKinds:[...o[t.key]]},e[t.key]=n);const r={value:t.value,count:t.count};void 0!==t.variation&&null!==t.variation&&(r.variation=t.variation),void 0!==t.version&&null!==t.version?r.version=t.version:r.unknown=!0,n.counters.push(r),i=!1}return i?null:{startDate:t,endDate:n,features:e}},e.clearSummary=()=>{t=0,n=0,r={},o={}},e};function xe(e){return e.replace(/~/g,"~0").replace(/\//g,"~1")}function Ce(e){return(e.startsWith("/")?e.substring(1):e).split("/").map((e=>e.indexOf("~")>=0?e.replace(/~1/g,"/").replace(/~0/g,"~"):e))}function Pe(e){return!e.startsWith("/")}function Se(e,t){const n=Pe(e),r=Pe(t);if(n&&r)return e===t;if(n){const n=Ce(t);return 1===n.length&&e===n[0]}if(r){const n=Ce(e);return 1===n.length&&t===n[0]}return e===t}function Ie(e){return`/${xe(e)}`}var Oe={cloneExcluding:function(e,t){const n=[],r={},o=[];for(n.push(...Object.keys(e).map((t=>({key:t,ptr:Ie(t),source:e,parent:r,visited:[e]}))));n.length;){const e=n.pop();if(t.some((t=>Se(t,e.ptr))))o.push(e.ptr);else{const t=e.source[e.key];if(null===t)e.parent[e.key]=t;else if(Array.isArray(t))e.parent[e.key]=[...t];else if("object"==typeof t){if(e.visited.includes(t))continue;e.parent[e.key]={},n.push(...Object.keys(t).map((n=>{return{key:n,ptr:(r=e.ptr,o=xe(n),`${r}/${o}`),source:t,parent:e.parent[e.key],visited:[...e.visited,t]};var r,o})))}else e.parent[e.key]=t}}return{cloned:r,excluded:o.sort()}},compare:Se,literalToReference:Ie};var Te=function(e){const t={},n=e.allAttributesPrivate,r=e.privateAttributes||[],o=["key","kind","_meta","anonymous"],i=["name","ip","firstName","lastName","email","avatar","country"],a=(e,t)=>{if("object"!=typeof e||null===e||Array.isArray(e))return;const{cloned:i,excluded:a}=Oe.cloneExcluding(e,((e,t)=>(n||t&&e.anonymous?Object.keys(e):[...r,...e._meta&&e._meta.privateAttributes||[]]).filter((e=>!o.some((t=>Oe.compare(e,t))))))(e,t));return i.key=String(i.key),a.length&&(i._meta||(i._meta={}),i._meta.redactedAttributes=a),i._meta&&(delete i._meta.privateAttributes,0===Object.keys(i._meta).length&&delete i._meta),void 0!==i.anonymous&&(i.anonymous=!!i.anonymous),i};return t.filter=(e,t=!1)=>void 0===e.kind||null===e.kind?a((e=>{const t={...e.custom||{},kind:"user",key:e.key};void 0!==e.anonymous&&(t.anonymous=!!e.anonymous);for(const n of i)delete t[n],void 0!==e[n]&&null!==e[n]&&(t[n]=String(e[n]));return void 0!==e.privateAttributeNames&&null!==e.privateAttributeNames&&(t._meta=t._meta||{},t._meta.privateAttributes=e.privateAttributeNames.map((e=>e.startsWith("/")?Oe.literalToReference(e):e))),t})(e),t):"multi"===e.kind?((e,t)=>{const n={kind:e.kind},r=Object.keys(e);for(const o of r)if("kind"!==o){const r=a(e[o],t);r&&(n[o]=r)}return n})(e,t):a(e,t),t};const{getContextKeys:Le}=ke;var Ue=function(e,t,n,r=null,o=null,i=null){const a={},c=i||he(e,n,t),u=S.appendUrlPath(t.eventsUrl,"/events/bulk/"+n),l=De(),d=Te(t),f=t.samplingInterval,g=t.eventCapacity,v=t.flushInterval,p=t.logger;let m,h=[],y=0,w=!1,b=!1;function k(){return 0===f||0===Math.floor(Math.random()*f)}function E(e){const t=S.extend({},e);return"identify"===e.kind?t.context=d.filter(e.context):"feature"===e.kind?t.context=d.filter(e.context,!0):(t.contextKeys=Le(e.context,p),delete t.context),"feature"===e.kind&&(delete t.trackEvents,delete t.debugEventsUntilDate),t}function D(e){h.length<g?(h.push(e),b=!1):(b||(b=!0,p.warn(ie.eventCapacityExceeded())),r&&r.incrementDroppedEvents())}return a.enqueue=function(e){if(w)return;let t=!1,n=!1;var r;if(l.summarizeEvent(e),"feature"===e.kind?k()&&(t=!!e.trackEvents,n=!!(r=e).debugEventsUntilDate&&r.debugEventsUntilDate>y&&r.debugEventsUntilDate>(new Date).getTime()):t=k(),t&&D(E(e)),n){const t=S.extend({},e,{kind:"debug"});t.context=d.filter(t.context),delete t.trackEvents,delete t.debugEventsUntilDate,D(t)}},a.flush=function(){if(w)return Promise.resolve();const e=h,t=l.getSummary();return l.clearSummary(),t&&(t.kind="summary",e.push(t)),r&&r.setEventsInLastBatch(e.length),0===e.length?Promise.resolve():(h=[],p.debug(ie.debugPostingEvents(e.length)),c.sendEvents(e,u).then((e=>{e&&(e.serverTime&&(y=e.serverTime),s.isHttpErrorRecoverable(e.status)||(w=!0),e.status>=400&&S.onNextTick((()=>{o.maybeReportError(new s.LDUnexpectedResponseError(ie.httpErrorMessage(e.status,"event posting","some events were dropped")))})))})))},a.start=function(){const e=()=>{a.flush(),m=setTimeout(e,v)};m=setTimeout(e,v)},a.stop=function(){clearTimeout(m)},a};var Re=function(e){const t={},n={};return t.on=function(e,t,r){n[e]=n[e]||[],n[e]=n[e].concat({handler:t,context:r})},t.off=function(e,t,r){if(n[e])for(let o=0;o<n[e].length;o++)n[e][o].handler===t&&n[e][o].context===r&&(n[e]=n[e].slice(0,o).concat(n[e].slice(o+1)))},t.emit=function(e){if(!n[e])return;const t=n[e].slice(0);for(let e=0;e<t.length;e++)t[e].handler.apply(t[e].context,Array.prototype.slice.call(arguments,1))},t.getEvents=function(){return Object.keys(n)},t.getEventListenerCount=function(e){return n[e]?n[e].length:0},t.maybeReportError=function(t){t&&(n["error"]?this.emit("error",t):(e||console).error(t.message))},t};const Ae="ready",je="initialized",Fe="failed";var Ne=function(e){let t=!1,n=!1,r=null,o=null;const i=new Promise((t=>{const n=()=>{e.off(Ae,n),t()};e.on(Ae,n)})).catch((()=>{}));return{getInitializationPromise:()=>o||(t?Promise.resolve():n?Promise.reject(r):(o=new Promise(((t,n)=>{const r=()=>{e.off(je,r),t()},o=t=>{e.off(Fe,o),n(t)};e.on(je,r),e.on(Fe,o)})),o)),getReadyPromise:()=>i,signalSuccess:()=>{t||n||(t=!0,e.emit(je),e.emit(Ae))},signalFailure:o=>{t||n||(n=!0,r=o,e.emit(Fe,o),e.emit(Ae)),e.maybeReportError(o)}}};var $e=function(e,t,n,r){const o={};function i(){let e="";const o=r.getContext();return o&&(e=n||S.btoa(JSON.stringify(o))),"ld:"+t+":"+e}return o.loadFlags=()=>e.get(i()).then((e=>{if(null==e)return null;try{let t=JSON.parse(e);if(t){const e=t.$schema;void 0===e||e<1?t=S.transformValuesToVersionedValues(t):delete t.$schema}return t}catch(e){return o.clearFlags().then((()=>null))}})),o.saveFlags=t=>{const n=S.extend({},t,{$schema:1});return e.set(i(),JSON.stringify(n))},o.clearFlags=()=>e.clear(i()),o};var Ve=function(e,t){const n={};let r=!1;const o=e=>{r||(r=!0,t.warn(ie.localStorageUnavailable(e)))};return n.isEnabled=()=>!!e,n.get=t=>new Promise((n=>{e?e.get(t).then(n).catch((e=>{o(e),n(void 0)})):n(void 0)})),n.set=(t,n)=>new Promise((r=>{e?e.set(t,n).then((()=>r(!0))).catch((e=>{o(e),r(!1)})):r(!1)})),n.clear=t=>new Promise((n=>{e?e.clear(t).then((()=>n(!0))).catch((e=>{o(e),n(!1)})):n(!1)})),n};const{appendUrlPath:Me,base64URLEncode:qe,objectHasOwnProperty:He}=S,{getLDHeaders:ze,transformHeaders:Ke}=ge,{isHttpErrorRecoverable:_e}=s;var Je=function(e,t,n,r){const o=t.streamUrl,i=t.logger,a={},s=Me(o,"/eval/"+n),c=t.useReport,u=t.evaluationReasons,l=t.streamReconnectDelay,d=ze(e,t);let f,g=!1,v=null,p=null,m=null,h=null,y=null,w=0;function b(){const e=(t=function(){const e=l*Math.pow(2,w);return e>3e4?3e4:e}(),t-Math.trunc(.5*Math.random()*t));var t;return w+=1,e}function k(e){if(e.status&&"number"==typeof e.status&&!_e(e.status))return x(),i.error(ie.unrecoverableStreamError(e)),void(p&&(clearTimeout(p),p=null));const t=b();g||(i.warn(ie.streamError(e,t)),g=!0),C(!1),x(),E(t)}function E(e){p||(e?p=setTimeout(D,e):D())}function D(){let r;p=null;let a="";const l={headers:d,readTimeoutMillis:3e5};if(e.eventSourceFactory){null!=h&&(a="h="+h),c?e.eventSourceAllowsReport?(r=s,l.method="REPORT",l.headers["Content-Type"]="application/json",l.body=JSON.stringify(m)):(r=Me(o,"/ping/"+n),a=""):r=s+"/"+qe(JSON.stringify(m)),l.headers=Ke(l.headers,t),u&&(a=a+(a?"&":"")+"withReasons=true"),r=r+(a?"?":"")+a,x(),i.info(ie.streamConnecting(r)),f=(new Date).getTime(),v=e.eventSourceFactory(r,l);for(const e in y)He(y,e)&&v.addEventListener(e,y[e]);v.onerror=k,v.onopen=()=>{w=0}}}function x(){v&&(i.info(ie.streamClosing()),v.close(),v=null)}function C(e){f&&r&&r.recordStreamInit(f,!e,(new Date).getTime()-f),f=null}return a.connect=function(e,t,n){m=e,h=t,y={};for(const e in n||{})y[e]=function(t){g=!1,C(!0),n[e]&&n[e](t)};E()},a.disconnect=function(){clearTimeout(p),p=null,x()},a.isConnected=function(){return!!(v&&e.eventSourceIsActive&&e.eventSourceIsActive(v))},a};var Be=function(e){let t,n,r,o;const i={addPromise:(i,a)=>{t=i,n&&n(),n=a,i.then((n=>{t===i&&(r(n),e&&e())}),(n=>{t===i&&(o(n),e&&e())}))}};return i.resultPromise=new Promise(((e,t)=>{r=e,o=t})),i};const{transformHeaders:Ge,getLDHeaders:We}=ge,Xe="application/json";var Qe=function(e,t,n){const r=t.baseUrl,o=t.useReport,i=t.evaluationReasons,a=t.logger,c={},u={};function l(n,r){if(!e.httpRequest)return new Promise(((e,t)=>{t(new s.LDFlagFetchError(ie.httpUnavailable()))}));const o=r?"REPORT":"GET",i=We(e,t);r&&(i["Content-Type"]=Xe);let a=u[n];a||(a=Be((()=>{delete u[n]})),u[n]=a);const c=e.httpRequest(o,n,Ge(i,t),r),l=c.promise.then((e=>{if(200===e.status){if(e.header("content-type")&&e.header("content-type").substring(0,16)===Xe)return JSON.parse(e.body);{const t=ie.invalidContentType(e.header("content-type")||"");return Promise.reject(new s.LDFlagFetchError(t))}}return Promise.reject(function(e){return 404===e.status?new s.LDInvalidEnvironmentIdError(ie.environmentNotFound()):new s.LDFlagFetchError(ie.errorFetchingFlags(e.statusText||String(e.status)))}(e))}),(e=>Promise.reject(new s.LDFlagFetchError(ie.networkError(e)))));return a.addPromise(l,(()=>{c.cancel&&c.cancel()})),a.resultPromise}return c.fetchJSON=function(e){return l(S.appendUrlPath(r,e),null)},c.fetchFlagSettings=function(e,t){let s,c,u,d="";return o?(c=[r,"/sdk/evalx/",n,"/context"].join(""),u=JSON.stringify(e)):(s=S.base64URLEncode(JSON.stringify(e)),c=[r,"/sdk/evalx/",n,"/contexts/",s].join("")),t&&(d="h="+t),i&&(d=d+(d?"&":"")+"withReasons=true"),c=c+(d?"?":"")+d,a.debug(ie.debugPolling(c)),l(c,u)},c};var Ye=function(e,t){const n={};let r;return n.setContext=function(e){r=S.sanitizeContext(e),r&&t&&t(S.clone(r))},n.getContext=function(){return r?S.clone(r):null},e&&n.setContext(e),n};const{v1:Ze}=ee,{getContextKinds:et}=ke;var tt=function(e){function t(e){return null==e||"user"===e?"ld:$anonUserId":`ld:$contextKey:${e}`}function n(n,r){return null!==r.key&&void 0!==r.key?(r.key=r.key.toString(),Promise.resolve(r)):r.anonymous?function(n){return e.get(t(n))}(n).then((o=>{if(o)return r.key=o,r;{const o=Ze();return r.key=o,function(n,r){return e.set(t(r),n)}(o,n).then((()=>r))}})):Promise.reject(new s.LDInvalidUserError(ie.invalidContext()))}this.processContext=e=>{if(!e)return Promise.reject(new s.LDInvalidUserError(ie.contextNotSpecified()));const t=S.clone(e);if("multi"===e.kind){const e=et(t);return Promise.all(e.map((e=>n(e,t[e])))).then((()=>t))}return n(e.kind,t)}};const{v1:nt}=ee,{baseOptionDefs:rt}=de,{appendUrlPath:ot}=S;var it={DiagnosticId:function(e){const t={diagnosticId:nt()};return e&&(t.sdkKeySuffix=e.length>6?e.substring(e.length-6):e),t},DiagnosticsAccumulator:function(e){let t,n,r,o;function i(e){t=e,n=0,r=0,o=[]}return i(e),{getProps:()=>({dataSinceDate:t,droppedEvents:n,eventsInLastBatch:r,streamInits:o}),setProps:e=>{t=e.dataSinceDate,n=e.droppedEvents||0,r=e.eventsInLastBatch||0,o=e.streamInits||[]},incrementDroppedEvents:()=>{n++},setEventsInLastBatch:e=>{r=e},recordStreamInit:(e,t,n)=>{const r={timestamp:e,failed:t,durationMillis:n};o.push(r)},reset:i}},DiagnosticsManager:function(e,t,n,r,o,i,a){const s=!!e.diagnosticUseCombinedEvent,c="ld:"+o+":$diagnostics",u=ot(i.eventsUrl,"/events/diagnostic/"+o),l=i.diagnosticRecordingInterval,d=n;let f,g,v=!!i.streaming;const p={};function m(){return{sdk:w(),configuration:b(),platform:e.diagnosticPlatformData}}function h(e){i.logger&&i.logger.debug(ie.debugPostingDiagnosticEvent(e)),r.sendEvents(e,u,!0).then((()=>{})).catch((()=>{}))}function y(){h(function(){const e=(new Date).getTime();let t={kind:s?"diagnostic-combined":"diagnostic",id:a,creationDate:e,...d.getProps()};return s&&(t={...t,...m()}),d.reset(e),t}()),g=setTimeout(y,l),f=(new Date).getTime(),s&&function(){if(t.isEnabled()){const e={...d.getProps()};t.set(c,JSON.stringify(e))}}()}function w(){const t={...e.diagnosticSdkData};return i.wrapperName&&(t.wrapperName=i.wrapperName),i.wrapperVersion&&(t.wrapperVersion=i.wrapperVersion),t}function b(){return{customBaseURI:i.baseUrl!==rt.baseUrl.default,customStreamURI:i.streamUrl!==rt.streamUrl.default,customEventsURI:i.eventsUrl!==rt.eventsUrl.default,eventsCapacity:i.eventCapacity,eventsFlushIntervalMillis:i.flushInterval,reconnectTimeMillis:i.streamReconnectDelay,streamingDisabled:!v,allAttributesPrivate:!!i.allAttributesPrivate,diagnosticRecordingIntervalMillis:i.diagnosticRecordingInterval,usingSecureMode:!!i.hash,bootstrapMode:!!i.bootstrap,fetchGoalsDisabled:!i.fetchGoals,sendEventsOnlyForVariation:!!i.sendEventsOnlyForVariation}}return p.start=()=>{s?function(e){if(!t.isEnabled())return e(!1);t.get(c).then((t=>{if(t)try{const e=JSON.parse(t);d.setProps(e),f=e.dataSinceDate}catch(e){}e(!0)})).catch((()=>{e(!1)}))}((e=>{if(e){const e=(f||0)+l,t=(new Date).getTime();t>=e?y():g=setTimeout(y,e-t)}else 0===Math.floor(4*Math.random())?y():g=setTimeout(y,l)})):(h({kind:"diagnostic-init",id:a,creationDate:d.getProps().dataSinceDate,...m()}),g=setTimeout(y,l))},p.stop=()=>{g&&clearTimeout(g)},p.setStreaming=e=>{v=e},p}};var at=function(e,t){let n=!1;const r={type:e.type,name:e.name,synchronous:e.synchronous,method:(...o)=>{try{e.method(...o)}catch{n||(n=!0,t.warn(ie.inspectorMethodError(r.type,r.name)))}}};return r};const{onNextTick:st}=S,ct={flagUsed:"flag-used",flagDetailsChanged:"flag-details-changed",flagDetailChanged:"flag-detail-changed",clientIdentityChanged:"client-identity-changed"};Object.freeze(ct);var ut={InspectorTypes:ct,InspectorManager:function(e,t){const n={},r={[ct.flagUsed]:[],[ct.flagDetailsChanged]:[],[ct.flagDetailChanged]:[],[ct.clientIdentityChanged]:[]},o={[ct.flagUsed]:[],[ct.flagDetailsChanged]:[],[ct.flagDetailChanged]:[],[ct.clientIdentityChanged]:[]},i=e&&e.map((e=>at(e,t)));return i&&i.forEach((e=>{Object.prototype.hasOwnProperty.call(r,e.type)&&!e.synchronous?r[e.type].push(e):Object.prototype.hasOwnProperty.call(o,e.type)&&e.synchronous?o[e.type].push(e):t.warn(ie.invalidInspector(e.type,e.name))})),n.hasListeners=e=>r[e]&&r[e].length||o[e]&&o[e].length,n.onFlagUsed=(e,t,n)=>{const i=ct.flagUsed;o[i].length&&o[i].forEach((r=>r.method(e,t,n))),r[i].length&&st((()=>{r[i].forEach((r=>r.method(e,t,n)))}))},n.onFlags=e=>{const t=ct.flagDetailsChanged;o[t].length&&o[t].forEach((t=>t.method(e))),r[t].length&&st((()=>{r[t].forEach((t=>t.method(e)))}))},n.onFlagChanged=(e,t)=>{const n=ct.flagDetailChanged;o[n].length&&o[n].forEach((n=>n.method(e,t))),r[n].length&&st((()=>{r[n].forEach((n=>n.method(e,t)))}))},n.onIdentityChanged=e=>{const t=ct.clientIdentityChanged;o[t].length&&o[t].forEach((t=>t.method(e))),r[t].length&&st((()=>{r[t].forEach((t=>t.method(e)))}))},n}};const{LDTimeoutError:lt}=s;var dt=function(e,t){return new Promise(((n,r)=>{setTimeout((()=>{r(new lt(`${t} timed out after ${e} seconds.`))}),1e3*e)}))};const{commonBasicLogger:ft}=ne,{checkContext:gt,getContextKeys:vt}=ke,{InspectorTypes:pt,InspectorManager:mt}=ut,ht="change",yt="internal-change";var wt={initialize:function(e,t,n,r,o){const i=function(){if(n&&n.logger)return n.logger;return o&&o.logger&&o.logger.default||ft("warn")}(),a=Re(i),c=Ne(a),u=de.validate(n,a,o,i),l=mt(u.inspectors,i),d=u.sendEvents;let f=e,g=u.hash;const v=Ve(r.localStorage,i),p=he(r,f,u),m=u.sendEvents&&!u.diagnosticOptOut,h=m?it.DiagnosticId(f):null,y=m?it.DiagnosticsAccumulator((new Date).getTime()):null,w=m?it.DiagnosticsManager(r,v,y,p,f,u,h):null,b=Je(r,u,f,y),k=u.eventProcessor||Ue(r,u,f,y,a,p),E=Qe(r,u,f);let D,x,C,P={},I=u.streaming,O=!1,T=!1,L=!0;const U=u.stateProvider,R=Ye(null,(function(e){(function(e){if(U)return;e&&F({kind:"identify",context:e,creationDate:(new Date).getTime()})})(e),l.hasListeners(pt.clientIdentityChanged)&&l.onIdentityChanged(R.getContext())})),A=new tt(v),j=v.isEnabled()?$e(v,f,g,R):null;function F(e){f&&(U&&U.enqueueEvent&&U.enqueueEvent(e)||(e.context?(L=!1,!d||T||r.isDoNotTrack()||(i.debug(ie.debugEnqueueingEvent(e.kind)),k.enqueue(e))):L&&(i.warn(ie.eventWithoutContext()),L=!1)))}function N(e,t){l.hasListeners(pt.flagDetailChanged)&&l.onFlagChanged(e.key,H(t))}function $(){l.hasListeners(pt.flagDetailsChanged)&&l.onFlags(Object.entries(P).map((([e,t])=>({key:e,detail:H(t)}))).reduce(((e,t)=>(e[t.key]=t.detail,e)),{}))}function V(e,t,n,r){const o=R.getContext(),i=new Date,a={kind:"feature",key:e,context:o,value:t?t.value:null,variation:t?t.variationIndex:null,default:n,creationDate:i.getTime()},s=P[e];s&&(a.version=s.flagVersion?s.flagVersion:s.version,a.trackEvents=s.trackEvents,a.debugEventsUntilDate=s.debugEventsUntilDate),(r||s&&s.trackReason)&&t&&(a.reason=t.reason),F(a)}function M(e){return gt(e,!1)?Promise.resolve(e):Promise.reject(new s.LDInvalidUserError(ie.invalidContext()))}function q(e,t,n,r,o,i){let a,s;return P&&S.objectHasOwnProperty(P,e)&&P[e]&&!P[e].deleted?(s=P[e],a=H(s),null!==s.value&&void 0!==s.value||(a.value=t)):a={value:t,variationIndex:null,reason:{kind:"ERROR",errorKind:"FLAG_NOT_FOUND"}},n&&(o||s?.prerequisites?.forEach((e=>{q(e,void 0,n,!1,!1,!1)})),V(e,a,t,r)),!o&&i&&function(e,t){l.hasListeners(pt.flagUsed)&&l.onFlagUsed(e,t,R.getContext())}(e,a),a}function H(e){return{value:e.value,variationIndex:void 0===e.variation?null:e.variation,reason:e.reason||null}}function z(){if(x=!0,!R.getContext())return;const e=e=>{try{return JSON.parse(e)}catch(e){return void a.maybeReportError(new s.LDInvalidDataError(ie.invalidData()))}};b.connect(R.getContext(),g,{ping:function(){i.debug(ie.debugStreamPing());const e=R.getContext();E.fetchFlagSettings(e,g).then((t=>{S.deepEquals(e,R.getContext())&&_(t||{})})).catch((e=>{a.maybeReportError(new s.LDFlagFetchError(ie.errorFetchingFlags(e)))}))},put:function(t){const n=e(t.data);n&&(i.debug(ie.debugStreamPut()),_(n))},patch:function(t){const n=e(t.data);if(!n)return;const r=P[n.key];if(!r||!r.version||!n.version||r.version<n.version){i.debug(ie.debugStreamPatch(n.key));const e={},t=S.extend({},n);delete t.key,P[n.key]=t;const o=H(t);e[n.key]=r?{previous:r.value,current:o}:{current:o},N(n,t),J(e)}else i.debug(ie.debugStreamPatchIgnored(n.key))},delete:function(t){const n=e(t.data);if(n)if(!P[n.key]||P[n.key].version<n.version){i.debug(ie.debugStreamDelete(n.key));const e={};P[n.key]&&!P[n.key].deleted&&(e[n.key]={previous:P[n.key].value}),P[n.key]={version:n.version,deleted:!0},N(n,P[n.key]),J(e)}else i.debug(ie.debugStreamDeleteIgnored(n.key))}})}function K(){x&&(b.disconnect(),x=!1)}function _(e){const t={};if(!e)return Promise.resolve();for(const n in P)S.objectHasOwnProperty(P,n)&&P[n]&&(e[n]&&!S.deepEquals(e[n].value,P[n].value)?t[n]={previous:P[n].value,current:H(e[n])}:e[n]&&!e[n].deleted||(t[n]={previous:P[n].value}));for(const n in e)S.objectHasOwnProperty(e,n)&&e[n]&&(!P[n]||P[n].deleted)&&(t[n]={current:H(e[n])});return P={...e},$(),J(t).catch((()=>{}))}function J(e){const t=Object.keys(e);if(t.length>0){const n={};t.forEach((t=>{const r=e[t].current,o=r?r.value:void 0,i=e[t].previous;a.emit(ht+":"+t,o,i),n[t]=r?{current:o,previous:i}:{previous:i}})),a.emit(ht,n),a.emit(yt,P),u.sendEventsOnlyForVariation||U||t.forEach((t=>{V(t,e[t].current)}))}return D&&j?j.saveFlags(P):Promise.resolve()}function B(){const e=I||C&&void 0===I;e&&!x?z():!e&&x&&K(),w&&w.setStreaming(e)}function G(e){return e===ht||e.substr(0,7)===ht+":"}if("string"==typeof u.bootstrap&&"LOCALSTORAGE"===u.bootstrap.toUpperCase()&&(j?D=!0:i.warn(ie.localStorageUnavailable())),"object"==typeof u.bootstrap&&(P=function(e){const t=Object.keys(e),n="$flagsState",r="$valid",o=e[n];!o&&t.length&&i.warn(ie.bootstrapOldFormat()),!1===e[r]&&i.warn(ie.bootstrapInvalid());const a={};return t.forEach((t=>{if(t!==n&&t!==r){let n={value:e[t]};o&&o[t]?n=S.extend(n,o[t]):n.version=0,a[t]=n}})),a}(u.bootstrap)),U){const e=U.getInitialState();e?W(e):U.on("init",W),U.on("update",(function(e){e.context&&R.setContext(e.context);e.flags&&_(e.flags)}))}else(function(){if(!e)return Promise.reject(new s.LDInvalidEnvironmentIdError(ie.environmentNotSpecified()));return A.processContext(t).then(M).then((e=>(R.setContext(e),"object"==typeof u.bootstrap?X():D?j.loadFlags().then((e=>null==e?(P={},E.fetchFlagSettings(R.getContext(),g).then((e=>_(e||{}))).then(X).catch((e=>{Q(new s.LDFlagFetchError(ie.errorFetchingFlags(e)))}))):(P=e,S.onNextTick(X),E.fetchFlagSettings(R.getContext(),g).then((e=>_(e))).catch((e=>a.maybeReportError(e)))))):E.fetchFlagSettings(R.getContext(),g).then((e=>{P=e||{},$(),X()})).catch((e=>{P={},Q(e)})))))})().catch(Q);function W(e){f=e.environment,R.setContext(e.context),P={...e.flags},S.onNextTick(X)}function X(){i.info(ie.clientInitialized()),O=!0,B(),c.signalSuccess()}function Q(e){c.signalFailure(e)}const Y={waitForInitialization:function(e=void 0){if(null!=e){if("number"==typeof e)return function(e){e>5&&i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");const t=c.getInitializationPromise(),n=dt(e,"waitForInitialization");return Promise.race([n,t]).catch((e=>{throw e instanceof s.LDTimeoutError&&i.error(`waitForInitialization error: ${e}`),e}))}(e);i.warn("The waitForInitialization method was provided with a non-numeric timeout.")}return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."),c.getInitializationPromise()},waitUntilReady:()=>c.getReadyPromise(),identify:function(e,t,n){if(T)return S.wrapPromiseCallback(Promise.resolve({}),n);if(U)return i.warn(ie.identifyDisabled()),S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P)),n);const r=D&&j?j.clearFlags():Promise.resolve();return S.wrapPromiseCallback(r.then((()=>A.processContext(e))).then(M).then((e=>E.fetchFlagSettings(e,t).then((n=>{const r=S.transformVersionedValuesToValues(n);return R.setContext(e),g=t,n?_(n).then((()=>r)):r})))).then((e=>(x&&z(),e))).catch((e=>(a.maybeReportError(e),Promise.reject(e)))),n)},getContext:function(){return R.getContext()},variation:function(e,t){return q(e,t,!0,!1,!1,!0).value},variationDetail:function(e,t){return q(e,t,!0,!0,!1,!0)},track:function(e,t,n){if("string"!=typeof e)return void a.maybeReportError(new s.LDInvalidEventKeyError(ie.unknownCustomEventKey(e)));void 0!==n&&"number"!=typeof n&&i.warn(ie.invalidMetricValue(typeof n)),r.customEventFilter&&!r.customEventFilter(e)&&i.warn(ie.unknownCustomEventKey(e));const o=R.getContext(),c={kind:"custom",key:e,context:o,url:r.getCurrentUrl(),creationDate:(new Date).getTime()};o&&o.anonymous&&(c.contextKind=o.anonymous?"anonymousUser":"user"),null!=t&&(c.data=t),null!=n&&(c.metricValue=n),F(c)},on:function(e,t,n){G(e)?(C=!0,O&&B(),a.on(e,t,n)):a.on(...arguments)},off:function(e){if(a.off(...arguments),G(e)){let e=!1;a.getEvents().forEach((t=>{G(t)&&a.getEventListenerCount(t)>0&&(e=!0)})),e||(C=!1,x&&void 0===I&&K())}},setStreaming:function(e){const t=null===e?void 0:e;t!==I&&(I=t,B())},flush:function(e){return S.wrapPromiseCallback(d?k.flush():Promise.resolve(),e)},allFlags:function(){const e={};if(!P)return e;for(const t in P)S.objectHasOwnProperty(P,t)&&!P[t].deleted&&(e[t]=q(t,null,!u.sendEventsOnlyForVariation,!1,!0,!1).value);return e},close:function(e){if(T)return S.wrapPromiseCallback(Promise.resolve(),e);const t=()=>{T=!0,P={}},n=Promise.resolve().then((()=>{if(K(),w&&w.stop(),d)return k.stop(),k.flush()})).then(t).catch(t);return S.wrapPromiseCallback(n,e)}};return{client:Y,options:u,emitter:a,ident:R,logger:i,requestor:E,start:function(){d&&(w&&w.start(),k.start())},enqueueEvent:F,getFlagsInternal:function(){return P},getEnvironmentId:()=>f,internalChangeEventName:yt}},commonBasicLogger:ft,errors:s,messages:ie,utils:S,getContextKeys:vt},bt=wt.initialize,kt=wt.errors,Et=wt.messages;function Dt(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function xt(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Ct(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?xt(Object(n),!0).forEach((function(t){Dt(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):xt(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}var Pt=wt.commonBasicLogger;var St=function(e){return Pt(Ct({destination:console.log},e))};var It={promise:Promise.resolve({status:200,header:function(){return null},body:null})};function Ot(e,t,n,r,o){if(o&&!function(){var e=window.navigator&&window.navigator.userAgent;if(e){var t=e.match(/Chrom(e|ium)\/([0-9]+)\./);if(t)return parseInt(t[2],10)<73}return!0}())return It;var i=new window.XMLHttpRequest;for(var a in i.open(e,t,!o),n||{})Object.prototype.hasOwnProperty.call(n,a)&&i.setRequestHeader(a,n[a]);if(o){try{i.send(r)}catch(e){}return It}var s,c=new Promise((function(e,t){i.addEventListener("load",(function(){s||e({status:i.status,header:function(e){return i.getResponseHeader(e)},body:i.responseText})})),i.addEventListener("error",(function(){s||t(new Error)})),i.send(r)}));return{promise:c,cancel:function(){s=!0,i.abort()}}}var Tt=e=>{if("string"!=typeof e)throw new TypeError("Expected a string");return e.replace(/[|\\{}()[\]^$+*?.]/g,"\\$&").replace(/-/g,"\\x2d")};function Lt(e,t,n,r){var o,i,a=(("substring"===e.kind||"regex"===e.kind)&&r.includes("/")?t:t.replace(r,"")).replace(n,"");switch(e.kind){case"exact":i=t,o=new RegExp("^"+Tt(e.url)+"/?$");break;case"canonical":i=a,o=new RegExp("^"+Tt(e.url)+"/?$");break;case"substring":i=a,o=new RegExp(".*"+Tt(e.substring)+".*$");break;case"regex":i=a,o=new RegExp(e.pattern);break;default:return!1}return o.test(i)}function Ut(e,t){for(var n={},r=null,o=[],i=0;i<e.length;i++)for(var a=e[i],s=a.urls||[],c=0;c<s.length;c++)if(Lt(s[c],window.location.href,window.location.search,window.location.hash)){"pageview"===a.kind?t("pageview",a):(o.push(a),t("click_pageview",a));break}return o.length>0&&(r=function(e){for(var n=function(e,t){for(var n=[],r=0;r<t.length;r++)for(var o=e.target,i=t[r],a=i.selector,s=document.querySelectorAll(a);o&&s.length>0;){for(var c=0;c<s.length;c++)o===s[c]&&n.push(i);o=o.parentNode}return n}(e,o),r=0;r<n.length;r++)t("click",n[r])},document.addEventListener("click",r)),n.dispose=function(){document.removeEventListener("click",r)},n}function Rt(e,t){var n,r;function o(){r&&r.dispose(),n&&n.length&&(r=Ut(n,i))}function i(t,n){var r=e.ident.getContext(),o={kind:t,key:n.key,data:null,url:window.location.href,creationDate:(new Date).getTime(),context:r};return"click"===t&&(o.selector=n.selector),e.enqueueEvent(o)}return e.requestor.fetchJSON("/sdk/goals/"+e.getEnvironmentId()).then((function(e){e&&e.length>0&&(r=Ut(n=e,i),function(e,t){var n,r=window.location.href;function o(){(n=window.location.href)!==r&&(r=n,t())}!function e(t,n){t(),setTimeout((function(){e(t,n)}),n)}(o,e),window.history&&window.history.pushState?window.addEventListener("popstate",o):window.addEventListener("hashchange",o)}(300,o)),t()})).catch((function(n){e.emitter.maybeReportError(new kt.LDUnexpectedResponseError((n&&n.message,n.message))),t()})),{}}var At="goalsReady",jt={fetchGoals:{default:!0},hash:{type:"string"},eventProcessor:{type:"object"},eventUrlTransformer:{type:"function"},disableSyncEventPost:{default:!1}};function Ft(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=function(e){var t,n={userAgentHeaderName:"X-LaunchDarkly-User-Agent",synchronousFlush:!1};if(window.XMLHttpRequest){var r=e&&e.disableSyncEventPost;n.httpRequest=function(e,t,o,i){var a=n.synchronousFlush&!r;return n.synchronousFlush=!1,Ot(e,t,o,i,a)}}n.httpAllowsPost=function(){return void 0===t&&(t=!!window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest),t},n.httpFallbackPing=function(e){(new window.Image).src=e};var o,i=e&&e.eventUrlTransformer;n.getCurrentUrl=function(){return i?i(window.location.href):window.location.href},n.isDoNotTrack=function(){var e;return 1===(e=window.navigator&&void 0!==window.navigator.doNotTrack?window.navigator.doNotTrack:window.navigator&&void 0!==window.navigator.msDoNotTrack?window.navigator.msDoNotTrack:window.doNotTrack)||!0===e||"1"===e||"yes"===e};try{window.localStorage&&(n.localStorage={get:function(e){return new Promise((function(t){t(window.localStorage.getItem(e))}))},set:function(e,t){return new Promise((function(n){window.localStorage.setItem(e,t),n()}))},clear:function(e){return new Promise((function(t){window.localStorage.removeItem(e),t()}))}})}catch(e){n.localStorage=null}if(e&&e.useReport&&"function"==typeof window.EventSourcePolyfill&&window.EventSourcePolyfill.supportedOptions&&window.EventSourcePolyfill.supportedOptions.method?(n.eventSourceAllowsReport=!0,o=window.EventSourcePolyfill):(n.eventSourceAllowsReport=!1,o=window.EventSource),window.EventSource){var a=3e5;n.eventSourceFactory=function(e,t){var n=Ct(Ct({},{heartbeatTimeout:a,silentTimeout:a,skipDefaultHeaders:!0}),t);return new o(e,n)},n.eventSourceIsActive=function(e){return e.readyState===window.EventSource.OPEN||e.readyState===window.EventSource.CONNECTING}}return n.userAgent="JSClient",n.version="3.5.0",n.diagnosticSdkData={name:"js-client-sdk",version:"3.5.0"},n.diagnosticPlatformData={name:"JS"},n.diagnosticUseCombinedEvent=!0,n}(n),o=bt(e,t,n,r,jt),i=o.client,a=o.options,s=o.emitter,c=new Promise((function(e){var t=s.on(At,(function(){s.off(At,t),e()}))}));i.waitUntilGoalsReady=function(){return c},a.fetchGoals?Rt(o,(function(){return s.emit(At)})):s.emit(At),"complete"!==document.readyState?window.addEventListener("load",o.start):o.start();var u=function(){r.synchronousFlush=!0,i.flush().catch((function(){})),r.synchronousFlush=!1};return document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&u()})),window.addEventListener("pagehide",u),i}var Nt=St,$t=void 0,Vt="3.5.0";var Mt={initialize:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return console&&console.warn&&console.warn(Et.deprecated("default export","named LDClient export")),Ft(e,t,n)},version:Vt};


/***/ }),

/***/ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js":
/*!***************************************************************************!*\
  !*** ../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);



/***/ }),

/***/ "./actions/deteriorationModels.actions.ts":
/*!************************************************!*\
  !*** ./actions/deteriorationModels.actions.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.listDeteriorationModelGroupsResultsRejected = exports.listDeteriorationModelGroupsResultsResolved = exports.listDeteriorationModelGroupsResultsAction = exports.listDeteriorationModelAssetsResultsRejected = exports.listDeteriorationModelAssetsResultsResolved = exports.listDeteriorationModelAssetsResultsAction = exports.getIndustryStandardCurvesResolved = exports.getIndustryStandardCurvesAction = exports.listDeteriorationModelCurveConfigsRejected = exports.listDeteriorationModelCurveConfigsResolved = exports.listDeteriorationModelCurveConfigsAction = exports.getDeteriorationModelStatusRejected = exports.getDeteriorationModelStatusResolved = exports.getDeteriorationModelStatus = exports.getDeteriorationModelRejected = exports.getDeteriorationModelResolved = exports.getDeteriorationModel = exports.resetDeteriorationModels = exports.listDeteriorationModelsRejected = exports.listDeteriorationModelsResolved = exports.listDeteriorationModels = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.listDeteriorationModels = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/list'));
exports.listDeteriorationModelsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/listResolved'));
exports.listDeteriorationModelsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/listRejected'));
exports.resetDeteriorationModels = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/reset'));
exports.getDeteriorationModel = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/get'));
exports.getDeteriorationModelResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getResolved'));
exports.getDeteriorationModelRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getRejected'));
exports.getDeteriorationModelStatus = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatus'));
exports.getDeteriorationModelStatusResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatusResolved'));
exports.getDeteriorationModelStatusRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/getStatusRejected'));
exports.listDeteriorationModelCurveConfigsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/list'));
exports.listDeteriorationModelCurveConfigsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/listResolved'));
exports.listDeteriorationModelCurveConfigsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/curveConfigs/listRejected'));
exports.getIndustryStandardCurvesAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/industryStandardCurves/get'));
exports.getIndustryStandardCurvesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/industryStandardCurves/getResolved'));
exports.listDeteriorationModelAssetsResultsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/list'));
exports.listDeteriorationModelAssetsResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/listResolved'));
exports.listDeteriorationModelAssetsResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/assetsResults/listRejected'));
exports.listDeteriorationModelGroupsResultsAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/list'));
exports.listDeteriorationModelGroupsResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/listResolved'));
exports.listDeteriorationModelGroupsResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('deteriorationModels/groupsResults/listRejected'));


/***/ }),

/***/ "./actions/failureDefinition.actions.ts":
/*!**********************************************!*\
  !*** ./actions/failureDefinition.actions.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFailureDefinitionRunResultsRejected = exports.getFailureDefinitionRunResultsResolved = exports.getFailureDefinitionRunResults = exports.deleteFailureDefinitionRejected = exports.deleteFailureDefinitionResolved = exports.deleteFailureDefinition = exports.getFailureDefinitionRejected = exports.getFailureDefinitionResolved = exports.getFailureDefinitionAction = exports.listAllFailureDefinitionsRejected = exports.listAllFailureDefinitionsResolved = exports.listAllFailureDefinitions = exports.runFailureDefinitionRejected = exports.runFailureDefinitionResolved = exports.runFailureDefinition = exports.clearFailureDefinitionCreationState = exports.createFailureDefinitionRejected = exports.createFailureDefinitionResolved = exports.createFailureDefinition = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
exports.createFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/create'));
exports.createFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/createResolved'));
exports.createFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/createRejected'));
exports.clearFailureDefinitionCreationState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/clearCreationState'));
exports.runFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/run'));
exports.runFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/runResolved'));
exports.runFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/runRejected'));
exports.listAllFailureDefinitions = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAll'));
exports.listAllFailureDefinitionsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAllResolved'));
exports.listAllFailureDefinitionsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/listAllRejected'));
exports.getFailureDefinitionAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/get'));
exports.getFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getResolved'));
exports.getFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRejected'));
exports.deleteFailureDefinition = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/delete'));
exports.deleteFailureDefinitionResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/deleteResolved'));
exports.deleteFailureDefinitionRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/deleteRejected'));
exports.getFailureDefinitionRunResults = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResults'));
exports.getFailureDefinitionRunResultsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResultsResolved'));
exports.getFailureDefinitionRunResultsRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('failureDefinition/getRunResultsRejected'));


/***/ }),

/***/ "./actions/groupSets.actions.ts":
/*!**************************************!*\
  !*** ./actions/groupSets.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getGroupSetResolved = exports.getGroupSetAction = exports.listGroupSetsResolved = exports.listGroupSets = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.listGroupSets = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/list'));
exports.listGroupSetsResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/list/resolved'));
exports.getGroupSetAction = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSet/get'));
exports.getGroupSetResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('groupSets/get/resolved'));


/***/ }),

/***/ "./actions/inspections.actions.ts":
/*!****************************************!*\
  !*** ./actions/inspections.actions.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchInspectionStandardCodesRejected = exports.fetchInspectionStandardCodesResolved = exports.fetchInspectionStandardCodes = exports.fetchInspectionOverviewRejected = exports.fetchInspectionOverviewResolved = exports.fetchInspectionOverview = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.fetchInspectionOverview = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list'));
exports.fetchInspectionOverviewResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list/resolved'));
exports.fetchInspectionOverviewRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/list/rejected'));
exports.fetchInspectionStandardCodes = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list'));
exports.fetchInspectionStandardCodesResolved = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list/resolved'));
exports.fetchInspectionStandardCodesRejected = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('inspections/codes/list/rejected'));


/***/ }),

/***/ "./actions/rehab.actions.ts":
/*!**********************************!*\
  !*** ./actions/rehab.actions.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchFieldMetadataRejected = exports.fetchFieldMetadataResolved = exports.fetchFieldMetadataAction = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.fetchFieldMetadataAction = (0, toolkit_1.createAction)('rehab/fieldMetadata/fetch');
exports.fetchFieldMetadataResolved = (0, toolkit_1.createAction)('rehab/fieldMetadata/resolved');
exports.fetchFieldMetadataRejected = (0, toolkit_1.createAction)('rehab/fieldMetadata/rejected');


/***/ }),

/***/ "./apis/config.api.ts":
/*!****************************!*\
  !*** ./apis/config.api.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.apiEnv = void 0;
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config = (_a = {},
    // Sample config for overwritting service endpoints
    _a[lib_get_service_1.Environments.LOCAL] = {
        assets: 'https://saas-asset-management.info360-dev.com/dev',
        amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
        saasAmRehab: 'https://saas-am-rehab.wlc360a-c-uw2.autodesk.com/dev',
    },
    _a);
exports.apiEnv = localStorage.getItem('apiEnv') || undefined;
exports["default"] = config;


/***/ }),

/***/ "./apis/failureDefinition.api.ts":
/*!***************************************!*\
  !*** ./apis/failureDefinition.api.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var failureDefinitionApi = (0, lib_get_service_1.axiosWithHeaders)({
    config: config_api_1.default,
    service: 'saasPipeDeterioration',
    axiosCreateOpts: { timeout: 15000 },
});
exports["default"] = failureDefinitionApi;


/***/ }),

/***/ "./apis/inspection.api.ts":
/*!********************************!*\
  !*** ./apis/inspection.api.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.inspectionBaseUrl = void 0;
var config_api_1 = __importStar(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var axios_1 = __importDefault(__webpack_require__(/*! axios */ "../node_modules/axios/dist/browser/axios.cjs"));
var browser_cookies_1 = __importDefault(__webpack_require__(/*! browser-cookies */ "../node_modules/browser-cookies/src/browser-cookies.js"));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var options = {
    baseURL: (0, lib_get_service_1.getService)('amInspection', config_api_1.default, config_api_1.apiEnv),
    timeout: 30000,
};
var inspectionService = axios_1.default.create(options);
inspectionService.interceptors.request.use(function (config) {
    config.headers.Authorization = 'Bearer ' + browser_cookies_1.default.get('auth0.user.token');
    return config;
}, function (error) {
    Promise.reject(error);
});
exports["default"] = inspectionService;
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
exports.inspectionBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amInspection', config_api_1.default, config_api_1.apiEnv));


/***/ }),

/***/ "./apis/pipeDeterioration.api.ts":
/*!***************************************!*\
  !*** ./apis/pipeDeterioration.api.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var pipeDeteriorationApi = (0, lib_get_service_1.axiosWithHeaders)({
    config: config_api_1.default,
    service: 'saasPipeDeterioration',
    axiosCreateOpts: { timeout: 15000 },
});
exports["default"] = pipeDeteriorationApi;


/***/ }),

/***/ "./apis/rehab.api.ts":
/*!***************************!*\
  !*** ./apis/rehab.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var LDClient = __importStar(__webpack_require__(/*! launchdarkly-js-client-sdk */ "../node_modules/launchdarkly-js-client-sdk/dist/ldclient.es.js"));
var rehabService = (0, lib_get_service_1.axiosWithHeaders)({
    service: 'amRehab',
    config: config_api_1.default,
    axiosCreateOpts: { timeout: 30000 },
});
var cloudOsRehabBackendBaseUrl = (0, lib_get_service_1.getService)('saasAmRehab', config_api_1.default);
var LaunchDarklyClientSingleton = /** @class */ (function () {
    function LaunchDarklyClientSingleton() {
        this.instance = null;
        this.ldClient = null;
        if (this.instance) {
            return this.instance;
        }
        this.instance = this;
    }
    LaunchDarklyClientSingleton.prototype.getSiteCfg = function () {
        return __awaiter(this, void 0, void 0, function () {
            var env, configUrl, siteCfg, siteCfgJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        env = (0, stylovyze_1.getEnvironment)();
                        configUrl = (0, stylovyze_1.getConfigUrl)(env);
                        return [4 /*yield*/, fetch(configUrl, {
                                headers: {
                                    'Cache-Control': 'no-cache',
                                    Pragma: 'no-cache',
                                    Expires: '0',
                                },
                            })];
                    case 1:
                        siteCfg = _a.sent();
                        return [4 /*yield*/, siteCfg.json()];
                    case 2:
                        siteCfgJson = _a.sent();
                        return [2 /*return*/, siteCfgJson];
                }
            });
        });
    };
    LaunchDarklyClientSingleton.prototype.getClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var siteCfg, clientId, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.ldClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getSiteCfg()];
                    case 1:
                        siteCfg = _a.sent();
                        clientId = siteCfg.launchDarkly.clientSideId;
                        client = LDClient.initialize(clientId, {
                            key: 'temp-user-key',
                        });
                        return [4 /*yield*/, client.waitForInitialization(10)];
                    case 2:
                        _a.sent();
                        this.ldClient = client;
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.ldClient];
                }
            });
        });
    };
    return LaunchDarklyClientSingleton;
}());
var ldClientSingleton = new LaunchDarklyClientSingleton();
rehabService.interceptors.request.use(function (cfg) { return __awaiter(void 0, void 0, void 0, function () {
    var ldClient, useCloudOS;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ldClientSingleton.getClient()];
            case 1:
                ldClient = _a.sent();
                useCloudOS = ldClient.variation('use-saas-am-rehab-backend', false);
                if (useCloudOS) {
                    return [2 /*return*/, __assign(__assign({}, cfg), { baseURL: cloudOsRehabBackendBaseUrl })];
                }
                return [2 /*return*/, cfg];
        }
    });
}); });
exports["default"] = rehabService;


/***/ }),

/***/ "./sagas/deteriorationModels.sagas.ts":
/*!********************************************!*\
  !*** ./sagas/deteriorationModels.sagas.ts ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var deteriorationModels_actions_1 = __webpack_require__(/*! @Actions/deteriorationModels.actions */ "./actions/deteriorationModels.actions.ts");
var deteriorationModels_services_1 = __webpack_require__(/*! @Services/deteriorationModels.services */ "./services/deteriorationModels.services.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
function listDeteriorationModelsSaga(action) {
    var payload, e_1, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.getDeteriorationModels, action.payload)];
            case 1:
                payload = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelsResolved)({
                        pagination: payload.data.pagination,
                        data: payload.data.data.map(function (dm) {
                            return ({
                                id: dm.id,
                                tenantId: dm.tenant_id,
                                name: dm.name,
                                assetGroupSetId: dm.asset_group_set_id,
                                failureDefinitionId: dm.failure_definition_id,
                                status: (0, _Types_1.deteriorationModelStatusToStatusType)(dm.status),
                                createdBy: dm.created_by,
                                createdAt: dm.created_at,
                                trainedBy: dm.trained_by,
                                trainedAt: dm.trained_at,
                                latestTrainResultsId: dm.latest_train_results_id,
                                updatedBy: dm.updated_by,
                                updatedAt: dm.updated_at,
                                latestCurveConfigsId: dm.latest_curve_configs_id,
                                runBy: dm.run_by,
                                runAt: dm.run_at,
                                latestRunResultsId: dm.latest_run_results_id,
                            });
                        }),
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_1 = _c.sent();
                console.error('Error retrieving deterioration models:', e_1);
                response = e_1.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to list deterioration models')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchListDeteriorationModelsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.listDeteriorationModels, listDeteriorationModelsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getDeteriorationModelSaga(action) {
    var payload, data, e_2, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.getDeteriorationModelById, action.payload.id)];
            case 1:
                payload = _c.sent();
                data = payload.data.data;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.getDeteriorationModelResolved)({
                        id: data.id,
                        tenantId: data.tenant_id,
                        name: data.name,
                        assetGroupSetId: data.asset_group_set_id,
                        failureDefinitionId: data.failure_definition_id,
                        status: (0, _Types_1.deteriorationModelStatusToStatusType)(data.status, true),
                        createdBy: data.created_by,
                        createdAt: data.created_at,
                        trainedBy: data.trained_by,
                        trainedAt: data.trained_at,
                        latestTrainResultsId: data.latest_train_results_id,
                        updatedBy: data.updated_by,
                        updatedAt: data.updated_at,
                        latestCurveConfigsId: data.latest_curve_configs_id,
                        runBy: data.run_by,
                        runAt: data.run_at,
                        latestRunResultsId: data.latest_run_results_id,
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_2 = _c.sent();
                console.error('Error retrieving deterioration model:', e_2);
                response = e_2.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.getDeteriorationModelRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to get deterioration model')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchGetDeteriorationModelSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.getDeteriorationModel, getDeteriorationModelSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getDeteriorationModelStatusSaga(action) {
    var payload, data, e_3, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.getDeteriorationModelById, action.payload.id)];
            case 1:
                payload = _c.sent();
                data = payload.data.data;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.getDeteriorationModelStatusResolved)({
                        id: data.id,
                        status: (0, _Types_1.deteriorationModelStatusToStatusType)(data.status, true),
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                e_3 = _c.sent();
                console.error('Error retrieving deterioration model status:', e_3);
                response = e_3.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.getDeteriorationModelStatusRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetDeteriorationModelStatusSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.getDeteriorationModelStatus, getDeteriorationModelStatusSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function listDeteriorationModelCurveConfigsSaga(action) {
    var payload, data, e_4, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.listDeteriorationModelCurveConfigs, action.payload)];
            case 1:
                payload = _c.sent();
                data = payload.data;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelCurveConfigsResolved)({
                        response: {
                            pagination: data.pagination,
                            data: data.data.map(function (dm) { return ({
                                id: dm._id,
                                assetGroupId: dm.asset_group_id,
                                assetGroupName: dm.asset_group_name,
                                assetGroupDescription: dm.asset_group_description,
                                assetCount: dm.asset_count.toString(),
                                failureCount: dm.failure_count.toString(),
                                selectedCurveMethod: (0, _Types_1.mapCurveMethodResponseToCurveMethod)(dm.selected_curve_method.method),
                            }); }),
                        },
                        curveConfigs: data.data.map(function (dm) {
                            var _a, _b, _c, _d, _e, _f;
                            var curveMethod = (0, _Types_1.mapCurveMethodResponseToCurveMethod)(dm.selected_curve_method.method);
                            var partialResponse = {
                                curveConfigId: dm._id,
                                selectedCurveMethod: curveMethod,
                                reference: null,
                                data: null,
                            };
                            switch (curveMethod) {
                                case _Types_1.CurveMethod.FAILURE_DEFINITION:
                                    return __assign(__assign({}, partialResponse), { data: null, reference: (_a = dm.selected_curve_method.model) !== null && _a !== void 0 ? _a : null });
                                case _Types_1.CurveMethod.CUSTOM_CURVE:
                                    return __assign(__assign({}, partialResponse), { data: (_c = (_b = dm.selected_curve_method.custom_data) === null || _b === void 0 ? void 0 : _b.map(function (d) { return ({
                                            age: d.age,
                                            survivalProbability: d.survival_probability * 100,
                                        }); })) !== null && _c !== void 0 ? _c : null, reference: null });
                                case _Types_1.CurveMethod.INDUSTRY_CURVE:
                                    return __assign(__assign({}, partialResponse), { data: null, reference: (_d = dm.selected_curve_method.industry_curve_key) !== null && _d !== void 0 ? _d : null });
                                case _Types_1.CurveMethod.ONE_EXPECTED_LIFE:
                                    return __assign(__assign({}, partialResponse), { data: (_e = dm.selected_curve_method.life_expectancy) !== null && _e !== void 0 ? _e : null, reference: null });
                                case _Types_1.CurveMethod.COPIED_CURVE:
                                    return __assign(__assign({}, partialResponse), { data: null, reference: (_f = dm.selected_curve_method.curve_config_id_reference) !== null && _f !== void 0 ? _f : null });
                                default:
                                    return __assign(__assign({}, partialResponse), { data: null });
                            }
                        }),
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_4 = _c.sent();
                console.error('Error retrieving deterioration model curve configs:', e_4);
                response = e_4.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelCurveConfigsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to list deterioration model curve configs')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchListDeteriorationModelCurveConfigsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.listDeteriorationModelCurveConfigsAction, listDeteriorationModelCurveConfigsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getIndustryStandardCurvesSaga() {
    var payload, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.call)(deteriorationModels_services_1.getIndustryStandardCurves)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.getIndustryStandardCurvesResolved)(payload.data.data.map(function (curve) { return ({
                        displayName: curve.display_name,
                        key: curve.key,
                    }); })))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_5 = _a.sent();
                console.error('Error retrieving industry standard curves:', e_5);
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to retrieve industry standard curves')))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetIndustryStandardCurvesSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.getIndustryStandardCurvesAction, getIndustryStandardCurvesSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function listDeteriorationModelAssetsResultsSaga(action) {
    var payload, data, e_6, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.getDeteriorationModelAssetsResults, action.payload)];
            case 1:
                payload = _c.sent();
                data = payload.data;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelAssetsResultsResolved)({
                        pagination: data.pagination,
                        data: data.data.map(function (result) {
                            var _a, _b, _c, _d;
                            return ({
                                id: result.asset_id,
                                assetId: result.asset_id,
                                assetGroupName: result.asset_group_name,
                                age: (_a = result.age) === null || _a === void 0 ? void 0 : _a.toFixed(1),
                                failureProbability: (_b = result.failure_probability) === null || _b === void 0 ? void 0 : _b.toFixed(3),
                                rul: (_c = result.rul) === null || _c === void 0 ? void 0 : _c.toFixed(1),
                                failureYear: (_d = result.failure_year) === null || _d === void 0 ? void 0 : _d.toString(),
                                historicalFailure: (0, _Types_1.mapCurveMethodResponseToCurveMethod)(result.historical_failure),
                            });
                        }),
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_6 = _c.sent();
                console.error('Error retrieving deterioration model assets results:', e_6);
                response = e_6.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelAssetsResultsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to list deterioration model assets results')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchListDeteriorationModelAssetsResultsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.listDeteriorationModelAssetsResultsAction, listDeteriorationModelAssetsResultsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function listDeteriorationModelGroupsResultsSaga(action) {
    var payload, data, e_7, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, deteriorationModels_services_1.getDeteriorationModelGroupsResults, action.payload)];
            case 1:
                payload = _c.sent();
                data = payload.data;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelGroupsResultsResolved)({
                        pagination: data.pagination,
                        data: data.data.map(function (result) {
                            var _a, _b;
                            return ({
                                id: result._id,
                                assetGroupId: result.asset_group_id,
                                assetGroupName: result.asset_group_name,
                                assetGroupDescription: result.asset_group_description,
                                assetCount: (_a = result.asset_count) === null || _a === void 0 ? void 0 : _a.toFixed(0),
                                failureCount: (_b = result.failure_count) === null || _b === void 0 ? void 0 : _b.toFixed(0),
                                deteriorationMethod: (0, _Types_1.mapCurveMethodResponseToCurveMethod)(result.deterioration_method),
                            });
                        }),
                    }))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_7 = _c.sent();
                console.error('Error retrieving deterioration model groups results:', e_7);
                response = e_7.response;
                return [4 /*yield*/, (0, effects_1.put)((0, deteriorationModels_actions_1.listDeteriorationModelGroupsResultsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to list deterioration model groups results')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchListDeteriorationModelGroupsResultsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(deteriorationModels_actions_1.listDeteriorationModelGroupsResultsAction, listDeteriorationModelGroupsResultsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [
    watchListDeteriorationModelsSaga(),
    watchGetDeteriorationModelSaga(),
    watchGetDeteriorationModelStatusSaga(),
    watchListDeteriorationModelCurveConfigsSaga(),
    watchGetIndustryStandardCurvesSaga(),
    watchListDeteriorationModelAssetsResultsSaga(),
    watchListDeteriorationModelGroupsResultsSaga(),
];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/failureDefinition.sagas.ts":
/*!******************************************!*\
  !*** ./sagas/failureDefinition.sagas.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var failureDefinition_actions_1 = __webpack_require__(/*! @Actions/failureDefinition.actions */ "./actions/failureDefinition.actions.ts");
var failureDefinition_services_1 = __webpack_require__(/*! @Services/failureDefinition.services */ "./services/failureDefinition.services.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
function createFailureDefinitionSaga(action) {
    var tenantId, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 8]);
                tenantId = (0, lib_get_service_1.getTenantId)() || '';
                return [4 /*yield*/, (0, effects_1.call)(failureDefinition_services_1.newFailureDefinition, action.payload, tenantId)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.createFailureDefinitionResolved)({ id: response.data.failure_definition_id }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Failure definition created successfully')))];
            case 3:
                _a.sent();
                // Automatically run the failure definition after successful creation
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.runFailureDefinition)({ id: response.data.failure_definition_id }))];
            case 4:
                // Automatically run the failure definition after successful creation
                _a.sent();
                return [3 /*break*/, 8];
            case 5:
                e_1 = _a.sent();
                console.error('Error creating failure definition:', e_1);
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.createFailureDefinitionRejected)())];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to create failure definition')))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function runFailureDefinitionSaga(action) {
    var tenantId, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                tenantId = (0, lib_get_service_1.getTenantId)() || '';
                return [4 /*yield*/, (0, effects_1.call)(failureDefinition_services_1.runFailureDefinition, action.payload.id, tenantId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.runFailureDefinitionResolved)({ id: action.payload.id }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Failure definition run started successfully')))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4:
                e_2 = _a.sent();
                console.error('Error running failure definition:', e_2);
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.runFailureDefinitionRejected)({
                        code: -1,
                        text: (0, i18next_1.t)('Unable to run failure definition'),
                    }))];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to run failure definition')))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function deleteFailureDefinitionSaga(action) {
    var tenantId, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 8]);
                tenantId = (0, lib_get_service_1.getTenantId)() || '';
                return [4 /*yield*/, (0, effects_1.call)(failureDefinition_services_1.deleteFailureDefinition, action.payload.id, tenantId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.deleteFailureDefinitionResolved)({ id: action.payload.id }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Failure definition deleted successfully')))];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.listAllFailureDefinitions)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5:
                e_3 = _a.sent();
                console.error('Error deleting failure definition:', e_3);
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.deleteFailureDefinitionRejected)({
                        code: -1,
                        text: (0, i18next_1.t)('Unable to delete failure definition'),
                    }))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to delete failure definition')))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function watchCreateFailureDefinitionSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.createFailureDefinition, createFailureDefinitionSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchRunFailureDefinitionSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.runFailureDefinition, runFailureDefinitionSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchDeleteFailureDefinitionSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.deleteFailureDefinition, deleteFailureDefinitionSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function listAllFailureDefinitionsSaga() {
    var tenantId, payload, transformedFailureDefinitions, e_4, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                tenantId = (0, lib_get_service_1.getTenantId)() || '';
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, failureDefinition_services_1.getFailureDefinitions, tenantId)];
            case 1:
                payload = _c.sent();
                transformedFailureDefinitions = payload.data.failure_definitions.map(function (fd) { return ({
                    id: fd.id,
                    name: fd.name,
                    systemType: fd.system_type,
                    assetType: fd.asset_type,
                    inspectionStandard: fd.inspection_standard,
                    lastRunId: fd.last_run_id,
                    lastRunAt: fd.last_run_at,
                    status: (0, _Types_1.failureDefinitionStatusToStatusType)(fd.status),
                    runBy: fd.last_run_by,
                    createdAt: fd.created_at,
                    updatedAt: fd.updated_at,
                    assetCount: fd.asset_count,
                    events: fd.events,
                    inspections: fd.inspections,
                    tasks: fd.tasks,
                    prioritizedCategory: fd.prioritized_category,
                }); });
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.listAllFailureDefinitionsResolved)(transformedFailureDefinitions))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_4 = _c.sent();
                console.error('Error retrieving failure definitions:', e_4);
                response = e_4.response;
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.listAllFailureDefinitionsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to list failure definitions')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchListAllFailureDefinitionsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.listAllFailureDefinitions, listAllFailureDefinitionsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getFailureDefinitionSaga(action) {
    var tenantId, payload, data, transformedFailureDefinition, e_5, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 6]);
                tenantId = (0, lib_get_service_1.getTenantId)() || '';
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, failureDefinition_services_1.getFailureDefinition, action.payload, tenantId)];
            case 1:
                payload = _c.sent();
                data = payload.data.failure_definition;
                transformedFailureDefinition = {
                    id: data.id,
                    name: data.name,
                    systemType: data.system_type,
                    assetType: data.asset_type,
                    inspectionStandard: data.inspection_standard,
                    lastRunId: data.last_run_id,
                    events: data.events,
                    inspections: data.inspections,
                    tasks: data.tasks,
                    prioritizedCategory: data.prioritized_category,
                    status: (0, _Types_1.failureDefinitionStatusToStatusType)(data.status),
                    lastRunAt: data.last_run_at,
                    createdAt: data.created_at,
                    updatedAt: data.updated_at,
                    assetCount: data.asset_count,
                    runBy: data.last_run_by,
                };
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.getFailureDefinitionResolved)(transformedFailureDefinition))];
            case 2:
                _c.sent();
                return [3 /*break*/, 6];
            case 3:
                e_5 = _c.sent();
                console.error('Error retrieving failure definition:', e_5);
                response = e_5.response;
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.getFailureDefinitionRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to get failure definition')))];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchGetFailureDefinitionSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.getFailureDefinitionAction, getFailureDefinitionSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getFailureDefinitionRunResultsSaga(action) {
    var tenantId, request, payload, transformedResults, e_6, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 9]);
                tenantId = (0, lib_get_service_1.getTenantId)();
                if (!!tenantId) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.getFailureDefinitionRunResultsRejected)({
                        code: -1,
                        text: (0, i18next_1.t)('Authentication error: Tenant ID not available'),
                    }))];
            case 1:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Authentication error: Please log in again')))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                request = action.payload;
                return [4 /*yield*/, (0, effects_1.retry)(5, 15000, failureDefinition_services_1.getFailureDefinitionRunResults, request, tenantId)];
            case 4:
                payload = _c.sent();
                transformedResults = payload.data.data.map(function (apiResult) { return ({
                    id: apiResult.id,
                    tenantId: apiResult.tenant_id,
                    assetId: apiResult.asset_id,
                    runId: apiResult.run_id,
                    queryId: apiResult.query_id,
                    runBy: apiResult.run_by,
                    completedAt: apiResult.completed_at,
                    failureType: apiResult.failure_type,
                    failureDetail: apiResult.failure_detail,
                    failureDate: apiResult.failure_date,
                    installationDate: apiResult.installation_date,
                    ageAtFailure: apiResult.age_at_failure,
                    allFailures: apiResult.all_failures.map(function (failure) { return ({
                        failureType: failure.failure_type,
                        failureDetail: failure.failure_detail,
                        failureDate: failure.failure_date,
                    }); }),
                }); });
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.getFailureDefinitionRunResultsResolved)({
                        data: transformedResults,
                        pagination: payload.data.pagination,
                    }))];
            case 5:
                _c.sent();
                return [3 /*break*/, 9];
            case 6:
                e_6 = _c.sent();
                console.error('Error retrieving failure definition run results:', e_6);
                response = e_6.response;
                return [4 /*yield*/, (0, effects_1.put)((0, failureDefinition_actions_1.getFailureDefinitionRunResultsRejected)({
                        code: (_a = response === null || response === void 0 ? void 0 : response.status) !== null && _a !== void 0 ? _a : -1,
                        text: (_b = response === null || response === void 0 ? void 0 : response.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    }))];
            case 7:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Unable to get failure definition run results')))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchGetFailureDefinitionRunResultsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(failureDefinition_actions_1.getFailureDefinitionRunResults, getFailureDefinitionRunResultsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var failureDefinitionSagas = [
    watchCreateFailureDefinitionSaga(),
    watchRunFailureDefinitionSaga(),
    watchDeleteFailureDefinitionSaga(),
    watchListAllFailureDefinitionsSaga(),
    watchGetFailureDefinitionSaga(),
    watchGetFailureDefinitionRunResultsSaga(),
];
exports["default"] = failureDefinitionSagas;


/***/ }),

/***/ "./sagas/groupSets.sagas.ts":
/*!**********************************!*\
  !*** ./sagas/groupSets.sagas.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var groupSets_actions_1 = __webpack_require__(/*! @Actions/groupSets.actions */ "./actions/groupSets.actions.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var groupSets_services_1 = __webpack_require__(/*! @Services/groupSets.services */ "./services/groupSets.services.ts");
function listGroupSetsSaga() {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, groupSets_services_1.getGroupSets)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, groupSets_actions_1.listGroupSetsResolved)(payload.data.data))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchListGroupSetsSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(groupSets_actions_1.listGroupSets, listGroupSetsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getGroupSetSaga(action) {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.retry)(5, 15000, groupSets_services_1.getGroupSet, action.payload)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, groupSets_actions_1.getGroupSetResolved)(payload.data.data))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetGroupSetSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(groupSets_actions_1.getGroupSetAction, getGroupSetSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [watchListGroupSetsSaga(), watchGetGroupSetSaga()];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/index.ts":
/*!************************!*\
  !*** ./sagas/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var groupSets_sagas_1 = __importDefault(__webpack_require__(/*! ./groupSets.sagas */ "./sagas/groupSets.sagas.ts"));
var deteriorationModels_sagas_1 = __importDefault(__webpack_require__(/*! ./deteriorationModels.sagas */ "./sagas/deteriorationModels.sagas.ts"));
var inspections_sagas_1 = __importDefault(__webpack_require__(/*! ./inspections.sagas */ "./sagas/inspections.sagas.ts"));
var failureDefinition_sagas_1 = __importDefault(__webpack_require__(/*! ./failureDefinition.sagas */ "./sagas/failureDefinition.sagas.ts"));
var rehab_sagas_1 = __importDefault(__webpack_require__(/*! ./rehab.sagas */ "./sagas/rehab.sagas.ts"));
function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.all)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], groupSets_sagas_1.default, true), deteriorationModels_sagas_1.default, true), inspections_sagas_1.default, true), failureDefinition_sagas_1.default, true), rehab_sagas_1.default, true))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = rootSaga;


/***/ }),

/***/ "./sagas/inspections.sagas.ts":
/*!************************************!*\
  !*** ./sagas/inspections.sagas.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var inspections_actions_1 = __webpack_require__(/*! @Actions/inspections.actions */ "./actions/inspections.actions.ts");
var inspections_services_1 = __webpack_require__(/*! @Services/inspections.services */ "./services/inspections.services.ts");
function fetchInspectionOverviewSaga() {
    var response, err_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 10000, inspections_services_1.fetchInspectionsOverview)];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspections_actions_1.fetchInspectionOverviewResolved)(response))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3:
                err_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    (0, inspections_actions_1.fetchInspectionOverviewRejected)((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _a !== void 0 ? _a : 'Unknown error'))];
            case 4:
                _b.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchFetchInspectionOverviewSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(inspections_actions_1.fetchInspectionOverview, fetchInspectionOverviewSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function fetchInspectionStandardCodesSaga(action) {
    var standard, codes, error_1, message;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                standard = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, (0, effects_1.call)(inspections_services_1.fetchInspectionStandardCodesAPI, standard)];
            case 2:
                codes = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, inspections_actions_1.fetchInspectionStandardCodesResolved)({ standard: standard, codes: codes }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                error_1 = _a.sent();
                message = error_1 instanceof Error ? error_1.message : 'Unknown error';
                return [4 /*yield*/, (0, effects_1.put)((0, inspections_actions_1.fetchInspectionStandardCodesRejected)({
                        standard: standard,
                        error: message,
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchFetchInspectionStandardCodesSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(inspections_actions_1.fetchInspectionStandardCodes, fetchInspectionStandardCodesSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [watchFetchInspectionOverviewSaga(), watchFetchInspectionStandardCodesSaga()];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/rehab.sagas.ts":
/*!******************************!*\
  !*** ./sagas/rehab.sagas.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.watchFetchFieldMetadata = void 0;
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var rehab_actions_1 = __webpack_require__(/*! @Actions/rehab.actions */ "./actions/rehab.actions.ts");
var rehab_services_1 = __webpack_require__(/*! @Services/rehab.services */ "./services/rehab.services.ts");
function fetchFieldMetadataSaga(action) {
    var _a, type, systemType, assetType, inspectionStandard, result, error_1, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 5]);
                _a = action.payload, type = _a.type, systemType = _a.systemType, assetType = _a.assetType, inspectionStandard = _a.inspectionStandard;
                return [4 /*yield*/, (0, effects_1.call)(rehab_services_1.fetchFieldMetadata, type, // 'events', 'tasks', 'condition'
                    systemType, assetType, inspectionStandard)];
            case 1:
                result = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, rehab_actions_1.fetchFieldMetadataResolved)({ type: type, data: result }))];
            case 2:
                _b.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _b.sent();
                message = error_1 instanceof Error ? error_1.message : 'Unknown error';
                return [4 /*yield*/, (0, effects_1.put)((0, rehab_actions_1.fetchFieldMetadataRejected)({
                        type: action.payload.type,
                        error: message,
                    }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchFetchFieldMetadata() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeEvery)(rehab_actions_1.fetchFieldMetadataAction, fetchFieldMetadataSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.watchFetchFieldMetadata = watchFetchFieldMetadata;
var sagaArray = [watchFetchFieldMetadata()];
exports["default"] = sagaArray;


/***/ }),

/***/ "./services/deteriorationModels.services.ts":
/*!**************************************************!*\
  !*** ./services/deteriorationModels.services.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getDeteriorationModelGroupsResultsChart = exports.getDeteriorationModelGroupsResults = exports.groupsResultParamsMapping = exports.getDeteriorationModelAssetsResults = exports.assetsResultParamsMapping = exports.runModelById = exports.refreshTrainResults = exports.updateModelCurveConfigs = exports.inferFailureDefinition = exports.inferByIndustryStandardCurve = exports.getCurveConfig = exports.getIndustryStandardCurves = exports.searchDeteriorationModelCurveConfigs = exports.listDeteriorationModelCurveConfigs = exports.updateFailureDefinition = exports.updateDeteriorationModelName = exports.getDeteriorationModelById = exports.removeDeteriorationModel = exports.copyDeteriorationModel = exports.getDeteriorationModels = exports.newDeteriorationModel = void 0;
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var pipeDeterioration_api_1 = __importDefault(__webpack_require__(/*! @Apis/pipeDeterioration.api */ "./apis/pipeDeterioration.api.ts"));
var newDeteriorationModel = function (request) {
    return pipeDeterioration_api_1.default.post('deterioration-models', {
        model_name: request.modelName,
        asset_group_set_id: request.assetGroupSet,
        failure_definition_id: request.failureDefinition,
    });
};
exports.newDeteriorationModel = newDeteriorationModel;
var getDeteriorationModels = function (request) {
    return pipeDeterioration_api_1.default.get('deterioration-models', {
        params: {
            page: request.page,
            slice: request.slice,
            sort_key: request.sortKey,
            sort_descending: request.sortDescending,
            active_only: true,
        },
    });
};
exports.getDeteriorationModels = getDeteriorationModels;
var copyDeteriorationModel = function (id) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(id, "/copy"));
};
exports.copyDeteriorationModel = copyDeteriorationModel;
var removeDeteriorationModel = function (id) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(id, "/delete"));
};
exports.removeDeteriorationModel = removeDeteriorationModel;
var getDeteriorationModelById = function (id) {
    return pipeDeterioration_api_1.default.get("deterioration-models/".concat(id));
};
exports.getDeteriorationModelById = getDeteriorationModelById;
var updateDeteriorationModelName = function (request) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/update-name"), {
        new_model_name: request.newModelName,
    });
};
exports.updateDeteriorationModelName = updateDeteriorationModelName;
var updateFailureDefinition = function (request) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/update-failure-definition"), {
        new_failure_definition_id: request.newFailureDefinitionId,
    });
};
exports.updateFailureDefinition = updateFailureDefinition;
var operatorMap = {
    contains: 'contains',
    equals: 'equals',
    startsWith: 'starts with',
    endsWith: 'ends with',
    is: 'is',
    not: 'is not',
    '>': '>',
    '>=': '>=',
    '<': '<',
    '<=': '<=',
    '=': '=',
    '!=': '!=',
    isEmpty: 'is empty',
    isNotEmpty: 'is not empty',
    isAnyOf: 'is any of',
};
var curveMethodMap = {
    failureDefinition: 'failure_definition',
    industryCurve: 'industry_curve',
    customCurve: 'custom_curve',
    oneExpectedLife: 'one_expected_life',
    copiedCurve: 'copied_curve',
    undefined: null,
};
var listDeteriorationModelCurveConfigs = function (request) {
    var _a, _b, _c, _d, _e;
    var sortKey = '';
    if (request.sortKey === 'assetGroupName') {
        sortKey = 'asset_group_name';
    }
    else if (request.sortKey === 'assetGroupDescription') {
        sortKey = 'asset_group_description';
    }
    else if (request.sortKey === 'selectedCurveMethod') {
        sortKey = 'selected_curve_method';
    }
    else if (request.sortKey === 'assetCount') {
        sortKey = 'asset_count';
    }
    else if (request.sortKey === 'failureCount') {
        sortKey = 'failure_count';
    }
    var params = {
        page: request.page,
        slice: request.slice,
        sort_key: sortKey,
        sort_descending: request.sortDescending,
    };
    var filter = {};
    if ((_a = request.filter) === null || _a === void 0 ? void 0 : _a.assetGroupName) {
        filter.asset_group_name = {
            operator: operatorMap[request.filter.assetGroupName.operator],
            value: request.filter.assetGroupName.value,
        };
    }
    if ((_b = request.filter) === null || _b === void 0 ? void 0 : _b.assetGroupDescription) {
        filter.asset_group_description = {
            operator: operatorMap[request.filter.assetGroupDescription.operator],
            value: request.filter.assetGroupDescription.value,
        };
    }
    if ((_c = request.filter) === null || _c === void 0 ? void 0 : _c.selectedCurveMethod) {
        var value = null;
        if (Array.isArray(request.filter.selectedCurveMethod.value)) {
            value = request.filter.selectedCurveMethod.value.map(function (method) {
                return curveMethodMap[method];
            });
        }
        else if (request.filter.selectedCurveMethod.value) {
            value = curveMethodMap[request.filter.selectedCurveMethod.value];
        }
        filter.selected_curve_method = {
            operator: operatorMap[request.filter.selectedCurveMethod.operator],
            value: value,
        };
    }
    if ((_d = request.filter) === null || _d === void 0 ? void 0 : _d.assetCount) {
        filter.asset_count = {
            operator: operatorMap[request.filter.assetCount.operator],
            value: request.filter.assetCount.value,
        };
    }
    if ((_e = request.filter) === null || _e === void 0 ? void 0 : _e.failureCount) {
        filter.failure_count = {
            operator: operatorMap[request.filter.failureCount.operator],
            value: request.filter.failureCount.value,
        };
    }
    if (Object.keys(filter).length > 0) {
        params.filter = filter;
    }
    if (request.searchValue) {
        params.search_value = request.searchValue;
    }
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/curve-configs"), params);
};
exports.listDeteriorationModelCurveConfigs = listDeteriorationModelCurveConfigs;
var searchDeteriorationModelCurveConfigs = function (request) {
    var params = {
        page: 1,
        slice: 50,
        sort_key: 'asset_group_name',
        sort_descending: false,
        search_value: request.searchValue,
    };
    // Add filter for selected curve methods if provided
    if (request.selectedCurveMethods && request.selectedCurveMethods.length > 0) {
        params.filter = {
            selected_curve_method: {
                operator: 'is any of',
                value: request.selectedCurveMethods.map(function (method) {
                    if (method === _Types_1.CurveMethod.FAILURE_DEFINITION) {
                        return 'failure_definition';
                    }
                    else if (method === _Types_1.CurveMethod.INDUSTRY_CURVE) {
                        return 'industry_curve';
                    }
                    else if (method === _Types_1.CurveMethod.CUSTOM_CURVE) {
                        return 'custom_curve';
                    }
                    else if (method === _Types_1.CurveMethod.ONE_EXPECTED_LIFE) {
                        return 'one_expected_life';
                    }
                    else if (method === _Types_1.CurveMethod.COPIED_CURVE) {
                        return 'copied_curve';
                    }
                    else if (method === _Types_1.CurveMethod.UNDEFINED) {
                        return 'undefined';
                    }
                    return 'undefined';
                }),
            },
        };
    }
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/curve-configs"), params);
};
exports.searchDeteriorationModelCurveConfigs = searchDeteriorationModelCurveConfigs;
var getIndustryStandardCurves = function () {
    return pipeDeterioration_api_1.default.get('/industry-curves');
};
exports.getIndustryStandardCurves = getIndustryStandardCurves;
var getCurveConfig = function (modelId, curveConfigId) {
    return pipeDeterioration_api_1.default.get("deterioration-models/".concat(modelId, "/curve-configs/").concat(curveConfigId));
};
exports.getCurveConfig = getCurveConfig;
var inferByIndustryStandardCurve = function (request) {
    return pipeDeterioration_api_1.default.post('/industry-curves/infer', {
        curve_keys: request.curveKeys,
        ages: Array.from({ length: 100 }, function (_, index) { return index + 1; }),
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
exports.inferByIndustryStandardCurve = inferByIndustryStandardCurve;
var inferFailureDefinition = function (modelId, curveConfigId) {
    return pipeDeterioration_api_1.default.post("/deterioration-models/".concat(modelId, "/curve-configs/").concat(curveConfigId, "/infer/failure_definition"), {
        ages: Array.from({ length: 100 }, function (_, index) { return index + 1; }),
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
    });
};
exports.inferFailureDefinition = inferFailureDefinition;
var updateModelCurveConfigs = function (request) {
    var curveConfigs = request.curveConfigs.map(function (config) {
        if (config.selectedCurveMethod === _Types_1.CurveMethod.UNDEFINED) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: null,
            };
        }
        else if (config.selectedCurveMethod === _Types_1.CurveMethod.FAILURE_DEFINITION) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: {
                    method: 'failure_definition',
                    model: 'weibull',
                },
            };
        }
        else if (config.selectedCurveMethod === _Types_1.CurveMethod.INDUSTRY_CURVE) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: {
                    method: 'industry_curve',
                    industry_curve_key: config.industryCurve,
                },
            };
        }
        else if (config.selectedCurveMethod === _Types_1.CurveMethod.CUSTOM_CURVE) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: {
                    method: 'custom_curve',
                    custom_data: Array.isArray(config.customCurve)
                        ? config.customCurve.map(function (data) { return ({
                            age: data.age,
                            survival_probability: data.survivalProbability / 100,
                        }); })
                        : [],
                },
            };
        }
        else if (config.selectedCurveMethod === _Types_1.CurveMethod.ONE_EXPECTED_LIFE) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: {
                    method: 'one_expected_life',
                    life_expectancy: config.oneExpectedLife,
                },
            };
        }
        else if (config.selectedCurveMethod === _Types_1.CurveMethod.COPIED_CURVE) {
            return {
                curve_config_id: config.curveConfigId,
                selected_curve_method: {
                    method: 'copied_curve',
                    curve_config_id_reference: config.copiedCurve,
                },
            };
        }
    });
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/update-curve-configs"), { curve_configs: curveConfigs });
};
exports.updateModelCurveConfigs = updateModelCurveConfigs;
var refreshTrainResults = function (id) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(id, "/refresh"));
};
exports.refreshTrainResults = refreshTrainResults;
var runModelById = function (id) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(id, "/run"));
};
exports.runModelById = runModelById;
var assetsResultParamsMapping = function (request, forExport) {
    var _a, _b, _c, _d, _e, _f, _g;
    var sortKey = '';
    if (request.sortKey === 'assetId') {
        sortKey = 'asset_id';
    }
    else if (request.sortKey === 'assetGroupName') {
        sortKey = 'asset_group_name';
    }
    else if (request.sortKey === 'failureProbability') {
        sortKey = 'failure_probability';
    }
    else if (request.sortKey === 'rul') {
        sortKey = 'rul';
    }
    else if (request.sortKey === 'failureYear') {
        sortKey = 'failure_year';
    }
    else if (request.sortKey === 'age') {
        sortKey = 'age';
    }
    else if (request.sortKey === 'historicalFailure') {
        sortKey = 'historical_failure';
    }
    var params = {
        page: forExport ? request.page.toString() : request.page,
        slice: forExport ? request.slice.toString() : request.slice,
        sort_key: sortKey,
        sort_descending: forExport ? request.sortDescending.toString() : request.sortDescending,
    };
    var filter = {};
    if ((_a = request.filter) === null || _a === void 0 ? void 0 : _a.assetId) {
        filter.asset_id = {
            operator: operatorMap[request.filter.assetId.operator],
            value: request.filter.assetId.value,
        };
    }
    if ((_b = request.filter) === null || _b === void 0 ? void 0 : _b.assetGroupName) {
        filter.asset_group_name = {
            operator: operatorMap[request.filter.assetGroupName.operator],
            value: request.filter.assetGroupName.value,
        };
    }
    if ((_c = request.filter) === null || _c === void 0 ? void 0 : _c.failureProbability) {
        filter.failure_probability = {
            operator: operatorMap[request.filter.failureProbability.operator],
            value: request.filter.failureProbability.value,
        };
    }
    if ((_d = request.filter) === null || _d === void 0 ? void 0 : _d.age) {
        filter.age = {
            operator: operatorMap[request.filter.age.operator],
            value: request.filter.age.value,
        };
    }
    if ((_e = request.filter) === null || _e === void 0 ? void 0 : _e.rul) {
        filter.rul = {
            operator: operatorMap[request.filter.rul.operator],
            value: request.filter.rul.value,
        };
    }
    if ((_f = request.filter) === null || _f === void 0 ? void 0 : _f.failureYear) {
        filter.failure_year = {
            operator: operatorMap[request.filter.failureYear.operator],
            value: request.filter.failureYear.value,
        };
    }
    if ((_g = request.filter) === null || _g === void 0 ? void 0 : _g.historicalFailure) {
        filter.historical_failure = {
            operator: operatorMap[request.filter.historicalFailure.operator],
            value: request.filter.historicalFailure.value,
        };
    }
    if (Object.keys(filter).length > 0) {
        if (forExport) {
            params.filter = JSON.stringify(filter);
        }
        else {
            params.filter = filter;
        }
    }
    if (request.searchValue) {
        params.search_value = request.searchValue;
    }
    return params;
};
exports.assetsResultParamsMapping = assetsResultParamsMapping;
var getDeteriorationModelAssetsResults = function (request) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/run/").concat(request.runId, "/assets"), (0, exports.assetsResultParamsMapping)(request, false));
};
exports.getDeteriorationModelAssetsResults = getDeteriorationModelAssetsResults;
var groupsResultParamsMapping = function (request, forExport) {
    var _a, _b, _c, _d, _e;
    var sortKey = '';
    if (request.sortKey === 'assetGroupName') {
        sortKey = 'asset_group_name';
    }
    else if (request.sortKey === 'assetGroupDescription') {
        sortKey = 'asset_group_description';
    }
    else if (request.sortKey === 'assetCount') {
        sortKey = 'asset_count';
    }
    else if (request.sortKey === 'failureCount') {
        sortKey = 'failure_count';
    }
    else if (request.sortKey === 'deteriorationMethod') {
        sortKey = 'deterioration_method';
    }
    var params = {
        page: forExport ? request.page.toString() : request.page,
        slice: forExport ? request.slice.toString() : request.slice,
        sort_key: sortKey,
        sort_descending: forExport ? request.sortDescending.toString() : request.sortDescending,
    };
    var filter = {};
    if ((_a = request.filter) === null || _a === void 0 ? void 0 : _a.assetGroupName) {
        filter.asset_group_name = {
            operator: operatorMap[request.filter.assetGroupName.operator],
            value: request.filter.assetGroupName.value,
        };
    }
    if ((_b = request.filter) === null || _b === void 0 ? void 0 : _b.assetGroupDescription) {
        filter.asset_group_description = {
            operator: operatorMap[request.filter.assetGroupDescription.operator],
            value: request.filter.assetGroupDescription.value,
        };
    }
    if ((_c = request.filter) === null || _c === void 0 ? void 0 : _c.assetCount) {
        filter.asset_count = {
            operator: operatorMap[request.filter.assetCount.operator],
            value: request.filter.assetCount.value,
        };
    }
    if ((_d = request.filter) === null || _d === void 0 ? void 0 : _d.failureCount) {
        filter.failure_count = {
            operator: operatorMap[request.filter.failureCount.operator],
            value: request.filter.failureCount.value,
        };
    }
    if ((_e = request.filter) === null || _e === void 0 ? void 0 : _e.deteriorationMethod) {
        var value = null;
        if (Array.isArray(request.filter.deteriorationMethod.value)) {
            value = request.filter.deteriorationMethod.value.map(function (method) {
                return curveMethodMap[method];
            });
        }
        else if (request.filter.deteriorationMethod.value) {
            value = curveMethodMap[request.filter.deteriorationMethod.value];
        }
        filter.selected_curve_method = {
            operator: operatorMap[request.filter.deteriorationMethod.operator],
            value: value,
        };
    }
    if (Object.keys(filter).length > 0) {
        if (forExport) {
            params.filter = JSON.stringify(filter);
        }
        else {
            params.filter = filter;
        }
    }
    if (request.searchValue) {
        params.search_value = request.searchValue;
    }
    return params;
};
exports.groupsResultParamsMapping = groupsResultParamsMapping;
var getDeteriorationModelGroupsResults = function (request) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(request.modelId, "/run/").concat(request.runId, "/groups"), (0, exports.groupsResultParamsMapping)(request, false));
};
exports.getDeteriorationModelGroupsResults = getDeteriorationModelGroupsResults;
var getDeteriorationModelGroupsResultsChart = function (modelId, runId, groupId) {
    return pipeDeterioration_api_1.default.post("deterioration-models/".concat(modelId, "/run/").concat(runId, "/groups/infer"), {
        group_result_id: groupId,
    });
};
exports.getDeteriorationModelGroupsResultsChart = getDeteriorationModelGroupsResultsChart;


/***/ }),

/***/ "./services/failureDefinition.services.ts":
/*!************************************************!*\
  !*** ./services/failureDefinition.services.ts ***!
  \************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFailureDefinitionRunResults = exports.deleteFailureDefinition = exports.getFailureDefinition = exports.getFailureDefinitions = exports.runFailureDefinition = exports.newFailureDefinition = void 0;
var failureDefinition_api_1 = __importDefault(__webpack_require__(/*! @Apis/failureDefinition.api */ "./apis/failureDefinition.api.ts"));
var newFailureDefinition = function (request, tenantId) {
    return failureDefinition_api_1.default.post('failure-definitions', request, {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.newFailureDefinition = newFailureDefinition;
var runFailureDefinition = function (id, tenantId) {
    return failureDefinition_api_1.default.post("failure-definitions/".concat(id, "/actions/run"), {}, {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.runFailureDefinition = runFailureDefinition;
var getFailureDefinitions = function (tenantId) {
    return failureDefinition_api_1.default.get('failure-definitions', {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.getFailureDefinitions = getFailureDefinitions;
var getFailureDefinition = function (id, tenantId) {
    return failureDefinition_api_1.default.get("failure-definitions/".concat(id), {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.getFailureDefinition = getFailureDefinition;
var deleteFailureDefinition = function (id, tenantId) {
    return failureDefinition_api_1.default.post("failure-definitions/".concat(id, "/actions/delete"), {}, {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.deleteFailureDefinition = deleteFailureDefinition;
var getFailureDefinitionRunResults = function (request, tenantId) {
    return failureDefinition_api_1.default.post("/failure-definitions/".concat(request.failureDefinitionId, "/run/").concat(request.runId), {
        failure_definition_id: request.failureDefinitionId,
        run_id: request.runId,
        order_by: request.orderBy,
        order: request.order,
        filters: request.filters,
        search_text: request.searchText,
        page: request.page,
        page_size: request.pageSize,
        filter_logistic_operator: 'and',
    }, {
        headers: {
            'x-tenant-id': tenantId,
        },
    });
};
exports.getFailureDefinitionRunResults = getFailureDefinitionRunResults;


/***/ }),

/***/ "./services/groupSets.services.ts":
/*!****************************************!*\
  !*** ./services/groupSets.services.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getGroupSet = exports.getGroupSets = void 0;
var rehab_api_1 = __importDefault(__webpack_require__(/*! @Apis/rehab.api */ "./apis/rehab.api.ts"));
var getGroupSets = function () {
    return rehab_api_1.default.get('/rehabTrees?listAllAndTrees=true&treeType=AGSet');
};
exports.getGroupSets = getGroupSets;
var getGroupSet = function (groupSetId) {
    return rehab_api_1.default.get("/rehabTree/".concat(groupSetId));
};
exports.getGroupSet = getGroupSet;


/***/ }),

/***/ "./services/inspections.services.ts":
/*!******************************************!*\
  !*** ./services/inspections.services.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchInspectionStandardCodesAPI = exports.fetchInspectionsOverview = void 0;
var inspection_api_1 = __importDefault(__webpack_require__(/*! @Apis/inspection.api */ "./apis/inspection.api.ts"));
var fetchInspectionsOverview = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, inspection_api_1.default.get('/inspections', {
                        params: { overview: true },
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                error_1 = _a.sent();
                console.error('Failed to fetch inspections overview:', error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.fetchInspectionsOverview = fetchInspectionsOverview;
var fetchInspectionStandardCodesAPI = function (standard) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, inspection_api_1.default.get("\n\t\t\t\tcodes/".concat(encodeURIComponent(standard)))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.fetchInspectionStandardCodesAPI = fetchInspectionStandardCodesAPI;


/***/ }),

/***/ "./services/rehab.services.ts":
/*!************************************!*\
  !*** ./services/rehab.services.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchFieldMetadata = void 0;
var rehab_api_1 = __importDefault(__webpack_require__(/*! @Apis/rehab.api */ "./apis/rehab.api.ts"));
var fetchFieldMetadata = function (endpoint, systemType, assetType, standard) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rehab_api_1.default.get("rehabTree/fieldsByRecordType/".concat(endpoint), {
                    params: {
                        systemType: systemType,
                        assetType: assetType,
                        standard: standard,
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
exports.fetchFieldMetadata = fetchFieldMetadata;


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.routeNamespace = exports.moduleNamespace = void 0;
exports.moduleNamespace = 'venus';
exports.routeNamespace = '/deterioration';


/***/ }),

/***/ "./types/deteriorationModels.types.ts":
/*!********************************************!*\
  !*** ./types/deteriorationModels.types.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapCurveMethodResponseToCurveMethod = exports.CurveMethod = exports.deteriorationModelStatusToStatusType = exports.DeteriorationModelStatus = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var DeteriorationModelStatus;
(function (DeteriorationModelStatus) {
    DeteriorationModelStatus["initializing"] = "initializing";
})(DeteriorationModelStatus = exports.DeteriorationModelStatus || (exports.DeteriorationModelStatus = {}));
var deteriorationModelStatusToStatusType = function (status, extended) {
    if (extended === void 0) { extended = false; }
    switch (status) {
        case 'initializing':
            return extended ? DeteriorationModelStatus.initializing : stylovyze_1.StatusType.inProgress;
        case 'draft':
            return stylovyze_1.StatusType.complete;
        case 'in progress':
            return stylovyze_1.StatusType.inProgress;
        case 'completed':
            return stylovyze_1.StatusType.complete;
        case 'deleted':
            return stylovyze_1.StatusType.cancelled;
        default:
            return stylovyze_1.StatusType.failed;
    }
};
exports.deteriorationModelStatusToStatusType = deteriorationModelStatusToStatusType;
var CurveMethod;
(function (CurveMethod) {
    CurveMethod["UNDEFINED"] = "undefined";
    CurveMethod["FAILURE_DEFINITION"] = "failureDefinition";
    CurveMethod["CUSTOM_CURVE"] = "customCurve";
    CurveMethod["INDUSTRY_CURVE"] = "industryCurve";
    CurveMethod["COPIED_CURVE"] = "copiedCurve";
    CurveMethod["ONE_EXPECTED_LIFE"] = "oneExpectedLife";
})(CurveMethod = exports.CurveMethod || (exports.CurveMethod = {}));
var mapCurveMethodResponseToCurveMethod = function (method) {
    switch (method) {
        case 'undefined':
            return CurveMethod.UNDEFINED;
        case 'failure_definition':
            return CurveMethod.FAILURE_DEFINITION;
        case 'custom_curve':
            return CurveMethod.CUSTOM_CURVE;
        case 'industry_curve':
            return CurveMethod.INDUSTRY_CURVE;
        case 'copied_curve':
            return CurveMethod.COPIED_CURVE;
        case 'one_expected_life':
            return CurveMethod.ONE_EXPECTED_LIFE;
        default:
            return CurveMethod.UNDEFINED;
    }
};
exports.mapCurveMethodResponseToCurveMethod = mapCurveMethodResponseToCurveMethod;


/***/ }),

/***/ "./types/failureDefinition.types.ts":
/*!******************************************!*\
  !*** ./types/failureDefinition.types.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.failureDefinitionStatusToStatusType = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var failureDefinitionStatusToStatusType = function (status) {
    if (!status)
        return stylovyze_1.StatusType.failed;
    switch (status.toLowerCase()) {
        case 'completed':
            return stylovyze_1.StatusType.complete;
        case 'running':
        case 'in_progress':
        case 'in progress':
        case 'processing':
            return stylovyze_1.StatusType.inProgress;
        case 'failed':
        case 'error':
        case 'failure':
            return stylovyze_1.StatusType.failed;
        case 'cancelled':
        case 'canceled':
        case 'stopped':
            return stylovyze_1.StatusType.cancelled;
        default:
            return stylovyze_1.StatusType.failed;
    }
};
exports.failureDefinitionStatusToStatusType = failureDefinitionStatusToStatusType;


/***/ }),

/***/ "./types/groupSets.types.ts":
/*!**********************************!*\
  !*** ./types/groupSets.types.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/index.ts":
/*!************************!*\
  !*** ./types/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./store.types */ "./types/store.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./deteriorationModels.types */ "./types/deteriorationModels.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./failureDefinition.types */ "./types/failureDefinition.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./groupSets.types */ "./types/groupSets.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./inspections.types */ "./types/inspections.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./rehab.types */ "./types/rehab.types.ts"), exports);


/***/ }),

/***/ "./types/inspections.types.ts":
/*!************************************!*\
  !*** ./types/inspections.types.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InspectionStandardType = void 0;
var InspectionStandardType;
(function (InspectionStandardType) {
    InspectionStandardType["PACP"] = "PACP";
    InspectionStandardType["WSA05"] = "WSA05";
})(InspectionStandardType = exports.InspectionStandardType || (exports.InspectionStandardType = {}));


/***/ }),

/***/ "./types/rehab.types.ts":
/*!******************************!*\
  !*** ./types/rehab.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/store.types.ts":
/*!******************************!*\
  !*** ./types/store.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addRouteNamespace = exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;
var addRouteNamespace = function (route) { return config_store_1.routeNamespace + '/' + route; };
exports.addRouteNamespace = addRouteNamespace;


/***/ }),

/***/ "./utils/urlFormatting.ts":
/*!********************************!*\
  !*** ./utils/urlFormatting.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatUrlTrailing = void 0;
var formatUrlTrailing = function (url) { return (url.match(/\/$/) ? url : url + '/'); };
exports.formatUrlTrailing = formatUrlTrailing;


/***/ }),

/***/ "@innovyze/lib_get_service":
/*!********************************************!*\
  !*** external "@innovyze/lib_get_service" ***!
  \********************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__;

/***/ }),

/***/ "@redux-saga/core/effects":
/*!*******************************************!*\
  !*** external "@redux-saga/core/effects" ***!
  \*******************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__;

/***/ }),

/***/ "@innovyze/stylovyze":
/*!**********************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/stylovyze","commonjs2":"@innovyze/stylovyze","amd":"@Innovyze/Stylovyze","root":"@Innovyze/Stylovyze"} ***!
  \**********************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "i18next":
/*!**********************************************************************************************!*\
  !*** external {"commonjs":"i18next","commonjs2":"i18next","amd":"I18next","root":"I18next"} ***!
  \**********************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_i18next__;

/***/ }),

/***/ "../node_modules/axios/dist/browser/axios.cjs":
/*!****************************************************!*\
  !*** ../node_modules/axios/dist/browser/axios.cjs ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Axios v1.7.7 Copyright (c) 2024 Matt Zabriskie and contributors


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : __webpack_require__.g)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************

var utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv: hasStandardBrowserEnv,
  navigator: _navigator,
  origin: origin
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

var isURLSameOrigin = platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils$1.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })();

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

var resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders$1.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout);

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils$1.asap(unsubscribe);

    return signal;
  }
};

var composeSignals$1 = composeSignals;

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = composeSignals$1([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.7.7";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

module.exports = axios;
//# sourceMappingURL=axios.cjs.map


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./sagas/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Sagas.js.map